export default {
title: 'AELU',
ssv: 'ទិដ្ឋាការជំនាញជាក់លាក់',
what_ssv: 'តើទិដ្ឋាការជំនាញជាក់លាក់ជាអ្វី?',
representative_message: 'សារតំណាង',
aeru_feature: 'លក្ខណះពិសេសនៃAELU',
aeru_how_to_use: 'លំហូរនៃការប្រើប្រាស់',
aeru_q_a: 'សំនួរនឹងចម្លើយ',
aeru_function: 'មុខងារនៃAELU',
aeru_fee: 'ការចំនាយរបស់AELU',
login: 'ចូល',
db_top_comment1: 'ឧស្សាហកម្មដំបូងគេ(ការប្រលងបញ្ជាក់វិញ្ញាប័ណ្ណប័ត្រទិដ្ឋាការជំនាញជាក់លាក់)ការបណ្ដុះបណ្ដាលតាមរយះទូរស័ព្ទដៃ',
db_top_comment2: 'AELUគឺជាសេវាកម្មគេហទំព័រដែលគាំទ្រដល់ការទទួលបានទិដ្ឋាការជំនាញជាក់លាក់ដោយសិក្សាសម្រាប់ការប្រឡងព័ត៌មានប្រឡងនិងទីភ្នាក់ងារដាក់ពាក្យសុំ។',
db_top_pr: 'ចាប់យកឱកាសថ្មីជាមួយ“ ទិដ្ឋការជំនាញជាក់លាក់”',
member_regist: 'ការចុះឈ្មោះសមាជិក',
registration_support_organization: 'តើភ្នាក់ងារគាំទ្រការចុះឈ្មោះគឺជាអ្វី?',
rso_dec1: 'មានអង្គការចំនួនពីរនៅក្នុងប្រព័ន្ធជំនាញជាក់លាក់គឺ“ អង្គការពាក់ព័ន្ធជំនាញជាក់លាក់” និង“ អង្គការគាំទ្រការចុះឈ្មោះ” ។ ស្ថាប័នពាក់ព័ន្ធជំនាញជាក់លាក់មួយគឺជាក្រុមហ៊ុនមួយ (ទទួលយកស្ថាប័ន) ដែលផ្តល់ការងារដល់ជនបរទេសដែលមានជំនាញជាក់លាក់។ ស្ថាប័នដែលមានជំនាញជាក់លាក់ត្រូវតែផ្តល់ការគាំទ្រដល់ជនបរទេសដែលមានជំនាញជាក់លាក់នៅកន្លែងធ្វើការជីវិតប្រចាំថ្ងៃនិងសង្គម។',
rso_dec2: 'ចាប់តាំងពីការគាំទ្រដល់ជនបរទេសដែលមានជំនាញជាក់លាក់មានមាតិកាឯកទេសវាអាចជាការពិបាកសម្រាប់ក្រុមហ៊ុនដែលផ្តល់ការងារដល់ជនបរទេសដែលមានជំនាញជាក់លាក់ "ស្ថាប័នដែលជំនាញជាក់លាក់ជាកម្មសិទ្ធិ" ដើម្បីផ្តល់ការគាំទ្រ។ អង្គការគាំទ្រការចុះឈ្មោះគឺជាអង្គការដែលត្រូវបានប្រគល់ឱ្យអង្គការដែលមានជំនាញជាក់លាក់ក្នុងការបង្កើតនិងអនុវត្តផែនការគាំទ្រសម្រាប់ជនបរទេសដែលមានជំនាញជាក់លាក់។',
rso_dec3: 'អង្គការគាំទ្រការចុះឈ្មោះគឺជាអង្គការដែលត្រូវបានប្រគល់ឱ្យអង្គការដែលមានជំនាញជាក់លាក់ក្នុងការបង្កើតនិងអនុវត្តផែនការគាំទ្រសម្រាប់ជនបរទេសដែលមានជំនាញជាក់លាក់។',
rso_dec4: 'អង្គភាពគាំទ្រការចុះឈ្មោះនឹងផ្តល់ការគាំទ្រទាំងអស់ដោយផ្អែកលើផែនការគាំទ្រជនបរទេសដែលមានជំនាញលេខ ១ ក្រោមកិច្ចសន្យាផ្តល់ការគាំទ្រដល់អង្គការម្ចាស់ផ្ទះ។',
rso_dec5: 'ដើម្បីក្លាយជាភ្នាក់ងារគាំទ្រការចុះឈ្មោះអ្នកត្រូវចុះឈ្មោះដោយស្នងការការិយាល័យអន្តោប្រវេសន៍នៃប្រទេសជប៉ុន។',
rso_dec6: 'ស្ថាប័នចុះបញ្ជីនឹងត្រូវបានចុះឈ្មោះនៅក្នុងស្ថាប័នគាំទ្រចុះឈ្មោះនិងត្រូវបានចុះផ្សាយនៅលើគេហទំព័រការិយាល័យអន្តោប្រវេសន៍នៃប្រទេសជប៉ុន។',
rso_dec7: 'រយៈពេលចុះឈ្មោះគឺ ៥ ឆ្នាំហើយត្រូវការបន្តជាថ្មី។',
rso_dec8: 'អង្គការគាំទ្រការចុះឈ្មោះត្រូវតែបញ្ជូនសេចក្តីជូនដំណឹងផ្សេងៗទៅការិយាល័យអន្តោប្រវេសន៍ជប៉ុនជាប្រចាំ។',
article1: 'អ្វីទៅជាទិដ្ឋាការជំនាញជាក់លាក់?',
article1_dec1: 'ជាមួយនឹងការអនុម័តច្បាប់ត្រួតពិនិត្យជនអន្តោប្រវេសន៍ដែលត្រូវបានធ្វើវិសោធនកម្មកាលពីថ្ងៃទី ៨ ខែធ្នូឆ្នាំ ២០១៨ ស្ថានភាពនៃ“ ជំនាញជាក់លាក់” ត្រូវបានបង្កើតថ្មី។ អនុវត្តនៅខែមេសាឆ្នាំ ២០១៩ ។',
article1_dec2: 'ស្ថានភាពថ្មីនៃលំនៅដ្ឋាន "ជំនាញជាក់លាក់" នឹងត្រូវបានបង្កើតឡើងជាពីរដំណាក់កាល។ (លេខ ១ និងលេខ ២)',
article1_dec3: 'ឧស្សាហកម្មគោលដៅគឺឧស្សាហកម្មចំនួន ១៤ ។',
article1_dec4: 'តម្រូវការរបស់ជនបរទេសគោលដៅគឺជាមនុស្សម្នាក់ដែលមាន“ ជំនាញដែលត្រូវការចំណេះដឹងឬបទពិសោធន៍ច្រើន” ។ និយាយម៉្យាងទៀតអ្នកដែលបានបញ្ចប់វគ្គបណ្តុះបណ្តាលផ្នែកបច្ចេកទេសរយៈពេល ៣ ឆ្នាំឬអ្នកដែលប្រឡងជាប់តេស្តភាសានិងសមត្ថភាពភាសាជប៉ុនដែលមានសមត្ថភាពស្មើគ្នាមានសិទ្ធិទទួលបាន។',
article1_dec5: '“ ជំនាញពិសេសលេខ ១” ត្រូវបានអនុញ្ញាតឱ្យស្នាក់នៅរហូតដល់ ៥ ឆ្នាំជាមនុស្សដែលមានជំនាញជាក់លាក់។ សមាជិកគ្រួសារមិនត្រូវបានអនុញ្ញាតទេ។',
article1_dec6: '“ ជំនាញពិសេសលេខ ២” ត្រូវបានផ្តល់ឋានៈជាលំនៅដ្ឋានស្មើនឹងការងារទូទៅដោយឆ្លងកាត់ការប្រឡងជំនាញក្នុងអំឡុងពេលនៃជំនាញពិសេសលេខ ១ ជាមនុស្សដែលមានជំនាញច្បាស់លាស់។ (ដោយបន្តរយៈពេលនៃការស្នាក់នៅអ្នកអាចរស់នៅប្រកបដោយប្រសិទ្ធភាពជាអចិន្ត្រៃយ៍និងអនុញ្ញាតឱ្យគ្រួសាររបស់អ្នកអមដំណើរអ្នក។ )',
article2: 'សារតំណាង',
article2_sub1: 'សូមកុំបោះបង់ប្រទេសជប៉ុន',
article2_dec1: 'យើងសូមថ្លែងអំណរគុណយ៉ាងជ្រាលជ្រៅចំពោះសិក្ខាកាមបច្ចេកទេសនិងសិក្ខាកាមដែលបានវិលត្រឡប់មកប្រទេសជប៉ុនក្នុងនាមជាសិក្ខាកាមបច្ចេកទេសផ្នែកបច្ចេកទេសទទួលបានជំនាញនិងមិនមានការប្រឹងប្រែងសម្រាប់ការអភិវឌ្ឍប្រទេសរបស់ពួកគេ។ ខ្ញុំគិតថារូបរាងនៃការអនុវត្តដើម្បីជាប្រយោជន៍ដល់គ្រួសារនិងសម្រាប់ប្រទេសកំណើតដែលមិនមែននៅក្នុងប្រទេសជប៉ុនសព្វថ្ងៃនេះគឺជារូបរាងដើមរបស់មនុស្ស។ ខណៈពេលដែលខ្ញុំបានចូលរួមនៅក្នុងអាជីវកម្មបណ្តុះបណ្តាលបច្ចេកទេសអស់រយៈពេលជាយូរមកហើយមិនមានវិធីដើម្បីចូលក្នុងប្រទេសបានទេដោយមានទិដ្ឋាការអ្នកហាត់ការបច្ចេកទេសហើយខ្ញុំឆ្លៀតយកឱកាសនោះអនុវត្តយ៉ាងរឹងមាំនៅក្នុងប្រទេសជប៉ុនបើកអាជីវកម្មនៅក្នុងរបស់ខ្ញុំ ប្រទេសផ្ទាល់ខ្លួនហើយប្រទេសរបស់ខ្ញុំកំពុងអភិវឌ្ឍយ៉ាងខ្លាំងខ្ញុំបានឃើញច្រើន។ ទោះយ៉ាងណានៅខែមេសាឆ្នាំ ២០១៩ ទិដ្ឋាការ“ ជំនាញពិសេសជាក់លាក់” ត្រូវបានបង្កើត់ឡើងដើម្បីបំពេញបំណងប្រាថ្នាដើម្បីរីករាយជាមួយប្រទេសជប៉ុនដែលមិនអាចរៀនបានពេញលេញតាមចំនួនឆ្នាំដែលបានកំណត់។ ខ្ញុំសង្ឃឹមថាជនបរទេសជាច្រើនដែលមកលេងប្រទេសជប៉ុនដែលមានមហិច្ឆិតានៅពីក្រោយភ្នែកដែលកម្រមាននៅប្រទេសជប៉ុនអាចអភិវឌ្ឍប្រទេសជប៉ុនជាមួយគ្នា។ សំខាន់បំផុតខ្ញុំចង់មានប្រជាជនដូចជាជប៉ុនបង្កើនចំនួនអ្នករស់នៅជាអចិន្ត្រៃយ៍និងបង្កើតសង្គមមួយដែលពួកគេអាចរស់នៅជាមួយគ្នាបាន។',
article2_dec2: 'ការមើលឃើញរបស់ក្រុមហ៊ុន',
article2_dec3: 'ប្រធាននឹងនាយកប្រតិបត្តិ',
article2_dec4: 'កាហ្សូហ៊ីកូហូជីជី',
article3: 'លក្ខណៈពិសេសចំនួនបីដែលផ្តល់ដោយAELU',
article3_sub1: 'ការសិក្សាសំរាប់ការប្រលងតាមអ៊ីនធើណេត',
article3_sub1_dec1: 'ផ្តើមចេញពីសំនួរពីអតីតកាលនៃ“ AERU” ដែលអនុញ្ញាតឱ្យអ្នកត្រៀមប្រលងជំនាញជាក់លាក់នៅលើស្មាតហ្វូនរបស់អ្នកអ្នកអាចរៀបចំសំនួរដែលត្រាប់តាមដោយអ្នកជំនាញបន្ទាប់ពីសំនួរចំនួន ៣០ នៅក្នុងឧស្សាហកម្មទាំង ១៤ ហើយអ្នកអាចចាត់វិធានការជាច្រើនដងតាមដែលអ្នកចង់បាន។ កាលបរិច្ឆេទប្រឡង។ ប្រសិនបើអ្នកលើសពិន្ទុដែលបានបញ្ជាក់សម្រាប់សំណួរដែលត្រូវបានបង្កើតឡើងដោយAIអ្នកប្រាកដជានឹងប្រលងជាប់!',
article3_sub2: 'ពត៏មានការប្រលង',
article3_sub2_dec1: 'ពត៏មាននៃការប្រលងដែលពិបាកបំផុតសំរាប់ភ្ញៀវទេសចរបរទេសទៅប្រទេសជប៉ុនដើម្បីយល់នឹងត្រូវបានបន្ថែមដោយស្វ័យប្រវត្តិនៅពេលពត៏មានប្រលងឧស្សាហកម្មដែលត្រូវបានជ្រើសរើសបានធ្វើបច្ចុប្បន្នភាពបន្ទាប់ពីចុះឈ្មោះហើយអ្នកប្រើប្រាស់នឹងបានជូនដំណឹង',
article3_sub3: 'ការដាក់ពាក្យប្រលង',
article3_sub3_dec1: 'ដូចគ្នានឹងព័ត៌មាននៃការប្រឡងវាពិតជាលំបាកណាស់សម្រាប់ជនបរទេសដែលមកលេងប្រទេសជប៉ុនដើម្បីដាក់ពាក្យសុំប្រឡងហើយអ្នកមិនអាចសូម្បីតែប្រឡងដោយមិនបានបំពេញបែបបទតាមអ៊ិនធើណេត។ នៅពេលដែលអ្នកចុះឈ្មោះអ្នកអាចបញ្ចូលព័ត៌មានមានទម្រង់ពាក្យសុំរួចហើយនិងដាក់ពាក្យនៅពេលដំណាលគ្នានឹងការប្រកាសសាកល្បង។',
article4: 'ការណែនាំមុខងារបន្ទាប់ពីប្រលងជាប់',
article4_sub1: 'បេក្ខជនដែលទទួលបានជោគជ័យសូមប្រគល់ប្រាក់ត្រឡប់មកវិញដោយអបអរសាទរ (ទាំងក្នុងស្រុកនិងក្រៅស្រុក)',
article4_sub1_dec1: 'ប្រសិនបើអ្នករស់នៅក្នុងប្រទេសជប៉ុនរួចហើយនិងឆ្លងកាត់ការប្រើប្រាស់ AELU ហើយបញ្ចូលលេខសំងាត់និងវិញ្ញាបនប័ត្រឆ្លងទៅកាន់អេក្រង់អ្នកប្រើប្រាស់របស់អ្នកអ្នកអាចទទួលបានសាច់ប្រាក់វិញនៅថ្ងៃតែមួយផលិតផលត្រឡប់មកវិញតាមសាច់ប្រាក់៖ វិញ្ញាបនប័ត្រអំណោយតាមអ៊ិនធរណេត (អ៊ីម៉ែលវិញ្ញាបនប័ត្រអំណោយរបស់ Amazon) ប្រភេទ, Googleplay, កាតអំណោយរបស់ iTunes) ជាសាច់ប្រាក់ ៥០០០ យ៉េនដែលមានតំលៃពីគណនីផ្លូវការរបស់ LINE',
article4_sub2: 'យុទ្ធនាការណែនាំមិត្ត',
article4_sub2_dec1: 'អញ្ជើញអ្នកដាក់ពាក្យសុំទៅប្រទេសជប៉ុនដែលនៅប្រទេសជប៉ុនឬនៅបរទេសដើម្បីចូលរួមជាមួយគ្រុបហ្វេសបុកអ្នកប្រើប្រាស់នឹងប្រាប់ពីចំនួនអ្នកគ្រប់គ្រងខ្លួនឯងនឹងប្រគល់ប្រាក់ទៅអ្នកដែលទាក់ទងនឹងប្រាប់លេខវិញ្ញាបនប័ត្រអំណោយតាមអ៊ិនធើណេតចំនួន១០០០យ៉េនដល់អ្នកណែនាំក្នុងរយះពេលមួយបន្ទាប់ពីចូលរួម។',
article4_sub3: 'បន្ទាប់ពីទទួលបានទិដ្ឋការការផ្គូផ្គងស្វ័យប្រវត្តិAIសម្រាប់ស្វែងរកការងារ (មិនទាន់សំរេច)',
article4_sub3_dec1: 'បន្ទាប់ពីឆ្លងកាត់ការប្រឡងវិញ្ញាបនប័ត្រដោយប្រើAELUសូមបញ្ចូលលេខសំងាត់និងវិញ្ញាបនប័ត្រឆ្លងកាត់នៅលើអេក្រង់អ្នកប្រើប្រាស់ហើយអ្នកនឹងទទួលបានការផ្តល់ជូនដោយស្វ័យប្រវត្តិពីក្រុមហ៊ុនទាំងអស់នៅក្នុងប្រទេសជប៉ុន។ បទសម្ភាសន៍នឹងត្រូវបានធ្វើឡើងតាមអ៊ិនធើណេតហើយអ្នកនឹងអាចចូលទៅក្នុងប្រទេសផ្លាស់ទីនិងទទួលបានការងារដោយសន្តិភាពផ្លូវចិត្តដោយភ្ជាប់បណ្តាញអ៊ីនធើណេតសូម្បីតែនៅក្នុងជំពូកក្រៅផ្លូវការបឋមក៏ដោយ',
article4_sub4: 'ប្រគល់ប្រាក់វិញតាមរយៈការត្រួតពិនិត្យប័ណ្ណស្នាក់នៅជាប្រចាំ (មិនទាន់សម្រេច)',
article4_sub4_dec1: 'ប្រសិនបើអ្នកពិនិត្យមើលប័ណ្ណស្នាក់នៅរបស់អ្នកម្តងក្នុងមួយខែដោយមិនចាំបាច់ប្រើកម្មវិធីពិនិត្យប័ណ្ណស្នាក់នៅ "ផ្ទាំងឆែកមួយសន្លឹក" អ្នកនឹងទទួលបានសាច់ប្រាក់ ១០,០០០ យ៉េនក្នុង ១ ឆ្នាំ។',
article5: 'ការណែនាំមុខងារជាក់លាក់',
article5_sub1: 'អ្នកអាចមើលពីបញ្ហាដែលអ្នកបានដោះស្រាយ',
article5_sub1_dec1: 'អ្នកអាចកត់ខ្លឹមសារនៃការប្រលងដែលអ្នកបានបណ្តុះបណ្តាលតាមអ៊ិនធើណេតហើយប្រើឧបករណ៍ផ្ទាល់ខ្លួនដើម្បីយល់ពីទម្លាប់របស់អ្នកប្រើប្រាស់និងជំនះបញ្ហាដែលអ្នកមិនល្អ។ ដោយសារអ្នកអាចត្រៀមប្រលងបានច្រើនដងតាមដែលអ្នកចូលចិត្តកត់ត្រាប្រវត្តិពិន្ទុនិងពេលវេលាសាកល្បងទាំងអស់ហើយធ្វើឱ្យវាជិតបំផុតតាមដែលអាចធ្វើទៅបាននៅថ្ងៃប្រលងជាក់ស្តែង។ លើសពីនេះទៀតអ្នកអាចយល់ពីសំណួរកាន់តែច្បាស់ព្រោះអ្នកសរសេរទាំងភាសាផ្ទាល់ខ្លួននិងភាសាជប៉ុន។',
article5_sub2: 'រក្សាទុកប្រវត្តិរូបរបស់អ្នកជាអចិន្រ្តៃយ៍នៅពេលចូលប្រទេស',
article5_sub2_dec1: 'នៅពេលដែលអ្នកប្រលងតេស្តជំនាញជាក់លាក់និងដាក់ពាក្យសុំទិដ្ឋាការអ្នកនឹងត្រូវការប្រវត្តិរូបសង្ខេបនៅពេលអ្នកចូលប្រទេសជប៉ុនជាអ្នកបណ្តុះបណ្តាលផ្នែកបច្ចេកទេស។ ដើមឡើយត្រូវបានរក្សាទុកដោយអង្គការគ្រប់គ្រង (សហការ) ឬអង្គការបញ្ជូនអ្នកអាចរក្សាទុកវាដោយខ្លួនឯងបន្ទាប់ពីទទួលបានទិដ្ឋាការជំនាញជាក់លាក់។',
article5_sub3: 'មុខងារចុះឈ្មោះនៃប្រទេសរបស់អ្នក',
article5_sub3_dec1: 'ដោយសារភាសានៃប្រទេសរបស់អ្នកនិងប្រទេសជប៉ុនត្រូវបានប្រើជាមួយគ្នាអ្នកអាចយល់បានច្បាស់ពីសំណួរនិងចាត់វិធានការ។ នៅក្នុងការប្រឡងដើមមានតែភាសាជប៉ុនប៉ុណ្ណោះដែលអាចប្រើបានដូច្នេះអ្នកអាចចាត់វិធានការបានតែនៅក្នុងភាសាជប៉ុនប៉ុណ្ណោះ។',
article5_sub4: 'ការរំលឹកអំពីពត៏មាននឹងតម្រូវការនៃប្រឡងវិញ្ញាបនប័ត្រ',
article5_sub4_dec1: 'នៅពេលដែលកាលវិភាគសាកល្បងសម្រាប់មុខរបរដែលចង់បានត្រូវបានបញ្ចូលទៅក្នុង HP ដោយក្រុមសាកល្បងនីមួយៗវានឹងត្រូវបានរំលឹកដោយស្វ័យប្រវត្តិអ្នកប្រើប្រាស់នឹងត្រូវបានជូនដំណឹងកាលបរិច្ឆេទកាលបរិច្ឆេទនឹងត្រូវបានកំណត់នៅលើអេក្រង់អ្នកប្រើប្រាស់ហើយកម្មវិធីកំណត់ពេលវេលានឹងដំណើរការដោយស្វ័យប្រវត្តិ។',
article5_sub5: 'រៀនដោយការបញ្ចាំងស្លាយ',
article5_sub5_dec1: 'អ្នកអាចដកស្រង់ចំនុចខ្សោយរបស់អ្នកប្រើប្រាស់និងត្រៀមប្រលង។',
article5_sub6: 'ការពិគ្រោះយោបល់នឺងសំភាសន៍តាមអ៊ីនធើណេតដោយប្រើកាមេរ៉ាស្មាតហ្វូន',
article5_sub6_dec1: 'ខណៈពេលដែលប្រើអេហ្វឺរដើម្បីត្រៀមប្រលងវិញ្ញាបនប័ត្រអ្នកនឹងអាចបញ្ជាក់ពីអត្ថន័យនិងចេតនានៃសំនួរតាមទំរង់នៃការហៅទូរស័ព្ទនិងជជែក។ វាប្រហែលជាមិនចាំបាច់សម្រាប់អ្នកដែលមានទម្លាប់ធ្វើការនៅប្រទេសជប៉ុនឬអ្នកដែលមានការយល់ដឹងល្អអំពីប្រទេសជប៉ុននោះទេប៉ុន្តែសេវាពិគ្រោះយោបល់ហៅតាមទូរស័ព្ទគឺជាវិធីដែលអាចទុកចិត្តបំផុតដើម្បីពិនិត្យមើលការព្រួយបារម្ភមុនពេលប្រលង!',
article6: 'ចំនួនទឹកប្រាក់',
article6_sub1: 'ថ្លៃប្រើប្រាស់AELU',
article6_sub1_dec1: 'ការសិក្សាគ្មានដែនកំណត់នៃការប្រឡងបញ្ជាក់វិញ្ញាបនប័ត្រជំនាញជាក់លាក់គឺអាចធ្វើទៅបាន។ អ្នកអាចពិគ្រោះតាមអ៊ិនធរណេតជាភាសាកំណើតរបស់អ្នក។ អ្នកក៏អាចប្រើវាជាអ្នកបកប្រែក្នុងពេលធម្មតាដែរ។ ការជូនដំណឹងទៅកន្លែងសាកល្បងគឺអាចធ្វើទៅបាននៅថ្ងៃប្រលង។ សូមបន្តនៅលើធាតុដែលអាចត្រូវបានរក្សាទុកជារៀងរហូត។ បន្ទាប់ពីឆ្លងកាត់ការប្រឡងលោកអ្នកគ្រាន់តែចុះឈ្មោះលេខលិខិតឆ្លងដែនជំនាញជាក់លាក់របស់អ្នកហើយយើងនឹងណែនាំអ្នកអំពីការងារដែលអ្នកចង់បាន។ (មិនទាន់សម្រេចចិត្ត)',
article6_sub2: 'ទីភ្នាក់ងារដាក់ពាក្យប្រលង',
article6_sub2_dec1: 'អ្នកមិនអាចដាក់ពាក្យសុំក្នុងពេលធ្វើការបានទេហើយអ្នកក៏មិនអាចប្រឡងវិញ្ញាបនប័ត្របានដែរលើកលែងតែអ្នកដាក់ពាក្យដូច្នេះយើងនឹងដាក់ពាក្យសុំភ្លាមៗនៅពេលមានព័ត៌មានប្រឡងវិញ្ញាបនប័ត្រដើម្បីកុំអោយអ្នកខកខានកាលបរិច្ឆេទប្រឡង។',
article7: 'យុទ្ធនាការប្រាក់ត្រលប់មកវិញកំពុងដំនើរការ',
article7_dec1: 'អ្នកដែលប្រឡងជាប់អ្នកដែលបានចុះឈ្មោះលេខទិដ្ឋាការសម្រាប់សេវាកម្មនេះនឹងទទួលបានប្រាក់សំណង ៥,០០០ យ៉េន! ចុចត្រង់នេះដើម្បីចូលរួមក្នុងយុទ្ធនាការ',
article8: 'តោះចុះឈ្មោះនៅAELU',
dashboard: 'ផ្ទាំងគ្រប់គ្រង',
member_info: 'ចុះឈ្មោះពត៏មានប្រវត្តិរូប',
first_name: 'ឈ្មោះខ្លួនឯង',
midle_name: 'ឈ្មោះកណ្ដាល',
family_name: 'ឈ្មោះគ្រួសារ',
half_width_Roman: 'ឈ្មោះជាភាសាអង់គ្លេស',
password: 'លេខកូត',
password_confirm: 'លេខកូតបញ្ជាក់',
mail_adress: 'អាស័យដ្ឋានអ៊ីម៉ែល',
lineId: 'អាយឌីឡាញ(ក្នុងករណីទទួលសេវាតាមទូរស័ព្ទ)',
country_id: 'លេខកូតប្រទេស',
phone: 'លេខទូរស័ព្ទ',
issuing_country: 'ជ្រើសរើសប្រទេសឬតំបន់នៃការចេញអត្តសញ្ញាណប័ណ្ណ',
IDtype: 'ការជ្រើសរើសប្រភេទអត្តសញ្ញាណប័ណ្ណ',
residence_card: 'កាតស្នាក់នៅឬអត្តសញ្ញាណប័ណ្ណ',
passport: 'ប៉ាស្ព័រ',
regist: 'ការចុះឈ្មោះ',
is_required: 'គឺចាំបាច់',
sign_up: 'ចុះឈ្មោះ',
residence_front: 'ផ្ទុកលើផ្ទៃខាងមុខ',
residence_back: 'ផ្ទុកលើផ្ទៃខាងក្រោយ',
passport_upload: 'ការដំឡើងប៉ាស្ព័រ',
error_file: 'បញ្ចូលរូបភាពឡើងវិញ',
post_resume: 'បញ្ជូនប្រវត្តិរូបសង្ខេប',
resume_upload: 'ដំឡើងប្រវត្តិរូបសង្ខេប',
click_upload: 'ចុចលើពាក្យដំឡើង',
image_drop: 'អូសឬទម្លាក់រូបភាពឯកសារ',
select_language: 'ជ្រើសរើសភាសា',
vietnamese: 'ភាសាវៀតណាម',
chinese: 'ភាសាចិន',
english: 'ភាសាអង់គ្លេស',
khmer: 'ភាសាខ្មែរ',
indonesian: 'ភាសាឥណ្ឌូនេស៊ី',
tagalog: 'ភាសាតាហ្គាល',
burmese: 'ភាសាភូមា',
hindu: 'ភាសាហិណ្ឌូ',
lao: 'ភាសាឡាវ',
mongolian: 'ភាសាម៉ុងហ្គោល',
bengali: 'ភាសាបេងហ្គាល់',
sinhala: 'ភាសាស៊ីនហាឡា',
banglodesh: 'ភាសាបង់ក្លាដេស',
malay: 'ភាសាម៉ាឡេ',
nepali: 'ភាសានេប៉ាល់',
thai: 'ភាសាថៃ',
japanese: 'ភាសាជប៉ុន',
error_lang: 'សូមជ្រើសរើសបកប្រែជាភាសាកំនើត',
select_ouccupation: 'ជ្រើសរើសមុខរបរ',
select_max_three: 'អ្នកអាចជ្រើសរើសរហូតដល់បី។',
industry_id_1: 'ការងារផ្នែកថែទាំ',
industry_id_2: 'សំអាតអគារ',
industry_id_3: 'ឧស្សាហកម្មវត្ថុធាតុដើម',
industry_id_4: 'ឧស្សាហកម្មផលិតគ្រឿងម៉ាស៊ីន',
industry_id_5: 'ឧស្សាហកម្មទាក់ទងនឹងអគ្គិសនីនិងព័ត៌មានអេឡិចត្រូនិក',
industry_id_6: 'ការងារសំណង់',
industry_id_7: 'ឧស្សាហកម្មផលិតនាវា',
industry_id_8: 'ឧស្សាហកម្មថែទាំរថយន្ត',
industry_id_9: 'ឧស្សាហកម្មទេសចរណ៍',
industry_id_10: 'អាជីវកម្មកន្លែងស្នាក់នៅ',
industry_id_11: 'កសិកម្ម',
industry_id_12: 'នេសាទ',
industry_id_13: 'ផលិតអាហារនឹងភេសជ្ជះ',
industry_id_14: 'អាជីវកម្មភោជនីយដ្ឋាន',
industry: 'ឧស្សាហកម្ម',
error_occupation: 'សូមជ្រើសរើសមុខរបរមួយខាងលើ',
do: 'ធ្វើ',
news_tpic: 'ពត៏មាន',
days_until_exam: 'ចំនួនថ្ងៃដែលនៅសល់រហូតដល់ថ្ងៃប្រលង',
estimated_pass_rate: 'អត្រាឆ្លងដែលបានប៉ាន់ស្មាន',
average_score_taken: 'ពិន្ទុជាមធ្យមនៃការធ្វើតេស្តត្រូវបានយក',
exam: 'ការប្រលង',
let_aim: 'ដាក់គោលដៅ',
score: 'ពិន្ទុ',
solve_problem: 'ដោះស្រាយសំនួរ',
recommend_problem: 'បញ្ហាដែលបានណែនាំរបស់AELU',
solved_problem: 'បញ្ហាដែលបានដោះស្រាយនាពេលកន្លងមក',
looking_solved: 'បញ្ហាដែលមើលឃើញនាពេលកន្លងមក',
consultaion_service: 'សេវាកម្មពិគ្រោះយោបល់',
application_agency: 'សេវាកម្មដាក់ពាក្យប្រលង',
billing: 'វិក្ក័យប័ត្រ',
more_look: 'មើលបន្ថែមទៀត',
more_look2: 'មើលបន្ថែមទៀត',
facebook: 'ហ្វេសបុក',
google: 'ហ្គូហ្គល',
until_not_account: 'អ្នកដែលគ្មានអខោន',
or: 'ឬក៏',
other_way: 'របៀបធ្វើផ្សេងៗ',
not_have_account: 'អ្នកគ្មានអខោន',
have_account: 'អ្នកមានអខោន',
forgot_password: 'អ្នកភ្លេចលេខកូត',
this: 'ចុចទីនេះ',
at_login: 'ចូលត្រង់នេះ',
pass_condition: 'អក្សរក្រមលេខអក្សរទទឹងកន្លះអក្សរធំអក្សរ ៨ ឬច្រើនជាងនេះ',
at_sign_up: 'ចុះឈ្មោះថ្មីជាមួយ',
agreement1: 'ដោយយល់ព្រមតាមចំណុចខាងក្រោមហើយជ្រើសរើសបន្ត AELU',
terms: 'លក្ខខណ្ឌ​នៃ​សេវាកម្ម',
agreement2: 'យល់ស្រប',
agree: 'យល់ព្រមបន្ត',
account_confirm: 'លេខបញ្ជាក់',
confirm: 'បញ្ជាក់',
not_confirm: 'លេខបញ្ជាក់ដែលមិនអាចបញ្ជាក់',
move_confiirm: 'ផ្លាស់ទីតាំងទៅអេក្រង់ដែលបញចូលលេខកូតបញ្ជាក់',
top: 'ក្បាលដំបូង',
news_list: 'តារាងពត៏មាន',
problim_list: 'តារាងសំនួរ',
learning_consul: 'រៀនពិគ្រោះយោបល់',
agency: 'ពត៏មានប្រលង',
of_trend: 'អំពីនិន្នាការនៃការធ្វើតេស្ត',
start_test: 'ចាប់ផ្ដើមប្រលង',
study_mode: 'របៀបរៀន',
order_question: 'លេខរៀងសំនួរ',
of_question: 'សំនួរ',
question_current: 'សំនួរចម្លើយត្រឹមត្រូវ',
to_mypage: 'ទៅកាន់ទំព័ររបស់ខ្ញុំ',
correct_answer: 'ចម្លើយត្រឹមត្រូវ',
correct_answer_normal: 'ចម្លើយត្រឹមត្រូវ',
no_correct_answer: 'ចម្លើយមិនត្រឹមត្រូវ',
next: 'ទៅសំនួរបន្ទាប់',
finish_all: 'បញ្ចប់សំនួរទាំងអស់',
your_score: 'ពិន្ទុរបស់អ្នក',
is: 'គឹ',
result_description: 'អ្នកអាចដោះស្រាយបញ្ហាផ្សេងទៀតពី "មើលបញ្ជីបញ្ហា" ។ អ្នកក៏អាចក្រឡេកមើលទៅបញ្ហាដែលអ្នកបានដោះស្រាយកន្លងមកពីទំព័របញ្ជីបញ្ហា។',
back_quiz_list: 'មើលបញ្ជីបញ្ហា>',
retry: 'ឆ្លើយសំនួរម្ដងទៀត',
no_description: 'មិនមានការអត្ថាធិប្បាយទេ',
show_ans: 'មើលចម្លើយ',
of_solved_problem: 'បញ្ហាដែលបានដោះស្រាយនាពេលកន្លងមក',
of_solved_problem_list: 'មើលបញ្ហាដែលបានដោះស្រាយនាពេលកន្លងមក',
solved_description: 'អ្នកអាចក្រឡេកមើលការសាកល្បងរៀនសម្រាប់ការធ្វើតេស្តទិដ្ឋាការជំនាញជាក់លាក់នៃឧស្សាហកម្មថែទាំរយៈពេលវែង។',
before_result: 'មុនពេលចេញលទ្ធផល',
looking_back: 'ត្រលប់ទៅវិញ',
back_solved_problem_list: 'ត្រលប់ទៅមើលបញ្ហាដែលបានដោះស្រាយនាពេលកន្លងមក',
again_retry: 'ត្រលប់ទៅមើលបញ្ហានេះម្ដងទៀត',
done_member_regist: 'សូមអរគុណដែលបានចុះឈ្មោះជាសមាជិក',
done_member_regist_description: 'សេវាកម្មនីមួយៗនឹងអាចប្រើបានបន្ទាប់ពីអ្នកបង់ថ្លៃសេវាកម្មប្រើប្រាស់។ សូមចុះឈ្មោះព័ត៌មានបង់ប្រាក់របស់អ្នក។',
choose_payment: 'ជ្រើសរើសវីធីសាស្ត្របង់ប្រាក់',
service_content: 'សេវាកម្មខាងក្នុង',
test_info_service: 'សេវាកម្មពត៏មានអំពីការប្រលង',
usage_fee: 'ថ្លៃប្រើប្រាស់​',
test_fee: 'ថ្លៃប្រលង៥០០យ៉េន',
application_fee: 'ថ្លៃដាក់ពាក្យ២០០០០យ៉េន',
method_payment: 'របៀបបង់ប្រាក់',
LINE_pay: 'តាមរយះឡាញផេ',
line_pay_description: 'សូមរក្សាទុករូបភាពលេខកូដ QR និងធ្វើការទូទាត់ប្រាក់នៅក្នុងសេវាកម្ម LINE Pay ។ នៅពេលបង់ប្រាក់ជាមួយ LINE Pay វានឹងត្រូវការពេលវេលាសម្រាប់ការគ្រប់គ្រងដើម្បីបញ្ជាក់។',
save_qr: 'រក្សាលេខកូតQR',
next_stage: 'បន្ទាប់​',
credit_card: 'កាតក្រដិត',
copmplete_payment: 'ការបង់ត្រូវបានបញ្ចប់',
copmplete_payment_descript: 'ឥឡូវនេះការទូទាត់ត្រូវបានបញ្ចប់អ្នកអាចប្រើមុខងារសិក្សាការប្រឡងតាមអ៊ិនធរណេតព័ត៌មាននៃការប្រឡងនិងសេវាកម្មទីភ្នាក់ងារដាក់ពាក្យប្រឡង។',
start_sevice: 'ចាប់ផ្ដើមប្រើប្រាស់សេវាកម្ម',
to_payment: 'ទៅកាន់អេក្រង់ចំនាយ',
of_news_list: 'តារាងពត៏មាន',
done_payment: 'ការបង់ប្រាក់ត្រូវបានបញ្ចប់',
tv_consult: 'ការពិគ្រោះយោបល់តាមរយះវីដេអូទូរស័ព្ទ',
tell_consult: 'ការពិគ្រោះយោបល់តាមទូរស័ព្ទ',
learning_consul_descript01: 'ការដាក់ពាក្យប្រលង',
learning_consul_descript02: 'ធ្វើជំនួស',
money_unit: 'លុយយ៉េន',
learning_consul_unit: 'លើកទីមួយ',
fault_payment1: 'ការចំនាយត្រូវបរាជ័យ',
fault_payment2: 'សូមធ្វើការកែប្រែឡើងវិញម្ដងទៀត',
no_examination: 'មិនទាន់មានទេ',
no_exam: 'មិនទាន់មានការប្រលង',
undecided: 'មិនបានសំរេចចិត្ត',
retry_login: 'សូមចូលម្ដងទៀត',
no_problem: 'មិនមានការដោះស្រាយបញ្ហា',
do_problem: 'ដោះស្រាយបញ្ហា',
qa_title: 'តែងតែមានចម្ងល់',
search_category: 'បង្រួមតាមប្រភេទ',
search_freeward: 'ស្វែងរកតាមពាក្យឥតគិតថ្លៃ',
test_result: 'អនុវត្តលទ្ធផលតេស្ត',
to_top: 'ទៅទំព័រដើម',
missPassword: 'ខុសអាស័យដ្ឋានអ៊ីម៉ែលនឹងលេខកូត',
sample_problem: 'បទពិសោធន៍សិក្សាការប្រឡងតាមអ៊ីនធឺណិត',
exercises: 'លំហាត់អនុវត្ត',
let_exercises: 'ចូរដោះស្រាយបញ្ហាតែមួយប៉ុណ្ណោះ',
to_qa: 'មើលសំនួរនឹងចម្លើយ',
read_more: 'មើលបន្ថែម​',
account_setting: 'ការកំណត់​គណនី',
profile_setting: 'ការកំណត់ប្រវត្តិរូប',
notification_setting: 'ការកំណត់ការជូនដំណឹង',
logout: 'ចេញវិញ',
changeEmail: 'ដូរអ៊ីម៉េល',
changePassword: 'ដូរលេខកូត',
change: 'ផ្លាស់ប្ដូរ',
save: 'រក្សាទុក​',
change_success: 'ការផ្លាស់ប្ដូរជោគជ័យ',
now_password: 'លេខកូតឥលូវ',
new_password: 'លេខកូតថ្មី',
check_new_password: 'បញ្ជាក់លេខកូតថ្មី',
do_logout: 'ការចាកចេញបានសម្រេច',
done_learning_consul_payment: 'ការទូទាត់ត្រូវបានបញ្ចប់រួចហើយ',
past_exam: 'បញ្ហានាពេលកន្លង',
update_info: 'ធ្វើបច្ចុប្បន្នភាពព័ត៌មានចុងក្រោយ',
official_sns: 'ផ្លូវការSNS',
privacy_policy: 'គោលការណ៍​ភាព​ឯកជន',
terms_service: 'ល័ក្ខខ័ណ្ឌនៃការប្រើប្រាស់',
transaction_law: 'ការកត់សម្គាល់ផ្អែកលើច្បាប់ប្រតិបត្តិការពាណិជ្ជកម្មដែលបានបញ្ជាក់',
selectCountry: 'សូមជ្រើសរើសប្រទេស',
goInquiry: 'បន្តការសាកសួរ',
lineInquiry: 'ទាក់ទងមកយើងតាមរយៈបន្ទាត់',
regist_accept_certificate: 'ការចុះឈ្មោះលិខិតបញ្ជាក់ការទទួលបានទិដ្ឋាការជំនាញជាក់លាក់',
accept_certificate_description: 'អ្នកអាចចុះឈ្មោះវិញ្ញាបនប័ត្រនិងលេខរបស់អ្នក',
accept_certificate: 'វិញ្ញាបនប័ត្រ',
accept_number: 'លេខឆ្លងកាត់',
immigration_resume: 'បន្តចុះឈ្មោះនៅពេលចូលប្រទេស',
resendCode: 'ផ្ញើលេខកូដផ្ទៀងផ្ទាត់ឡើងវិញ',
line_at_register: 'ការសាកសួរព័ត៌មានតាមរយៈ LINE',
study: 'សិក្សាហើយក្រឡេកមើលទៅក្រោយ',
study_text: 'ទាញយកអត្ថបទសិក្សា',
do_resume_update: 'សូមបញ្ចូលប្រវត្តិរូបរបស់អ្នក',
done_resume_update: 'សូមអរគុណសម្រាប់ការចុះឈ្មោះប្រវត្តិរូបសង្ខេបរបស់អ្នក!',
regist_resume_enter: 'ការចុះឈ្មោះប្រវត្តិរូបសង្ខេបនៅពេលចូលប្រទេស',
about_company: 'អំពីក្រុមហ៊ុន',
add_exam_info_detail: 'ពត៌មានប្រឡងត្រូវបានបន្ថែម។ សូមចុចនៅទីនេះសម្រាប់ពត៌មានលម្អិតនិងកម្មវិធី',
regist_result_get_money: 'ចុះឈ្មោះលទ្ធផលប្រឡងរបស់អ្នកហើយទទួលបានប្រាក់របស់អ្នក',
detail: 'ពត៏មានលម្អិត',
about_withdrawal_subsc: 'អំពីការដកប្រាក់និងការលុបចោលការជាវ',
apply_withdrawal: 'ពាក្យសុំនីតិវិធីដកប្រាក់',
apply_subsc: 'ពាក្យសុំលុបចោលការជាវ',
about_withdrawal: 'ពាក្យសុំដកប្រាក់',
about_subsc: 'បញ្ឈប់ការជាវ',
exam_info: 'ពត៏មានប្រលង',
date: 'កាលបរិច្ឆេទនឹងពេលវេលា',
day: 'ថ្ងៃ',
place: 'ទីកន្លែង',
result_publication: 'ប្រកាសលទ្ធផល',
result_publication_place: 'ទីកន្លែងប្រកាសលទ្ធផល',
result_this_page: 'ការប្រកាសលទ្ធផលនៅក្នុងទំព័រនេះ',
exam_way: 'ទ្រង់ទ្រាយប្រលង',
exam_way2: 'ទម្រង់សំណួរនៃការប្រឡង',
include_exam_fee: 'រួមទាំងថ្លៃប្រលង',
exam_application_desc: 'ការដាក់ពាក្យសុំចូលប្រលង \ n បន្សំជាមួយលេខាធិការដ្ឋាននៃការប្រឡង \ n ទាក់ទងនឹងអ្វីដែលត្រូវរៀបចំនៅថ្ងៃ (LINE @) \ n ទទួលបានសំនួរទាក់ទងនឹងការប្រលង',
self_application: 'ការដាក់ពាក្យប្រលងដោយខ្លួនឯង',
application_method: 'របៀបដាក់ពាក្យ',
under_this_url: 'សូមបំពេញបែបបទដាក់ពាក្យសុំពី URL ខាងក្រោម',
do_appliction: 'ការដាក់ពាក្យប្រលង',
study_with_aeru: 'ប្រើមុខងារសិក្សាប្រឡងពីទំព័រខាងលើដើម្បីបង្កើនអត្រាប្រឡង',
line_at_consul: 'សេវាកម្មប្រឹក្សាយោបល់រៀនតាមLine',
instagram: 'Instagram',
do_signup: 'អ្នកត្រូវបានផ្ទៀងផ្ទាត់ភាពត្រឹមត្រូវ។ សូមចូលម្តងទៀត។',
gender: 'ភេទ',
man: 'ប្រុស',
woman: 'ស្រី',
input_problem_title: 'បញ្ខូលចំណងជើងបញ្ហា',
still_no_problem: 'មិនមានបញ្ហា',
enter_in_problem_trend: 'មានការពន្យល់សង្ខេបនៃការប្រលងដូចជានិន្នាការនៃការប្រលងរហូតមកដល់ពេលនេះនិងទំរង់ចម្លើយ (ប្រភេទជំរើស) ។',
correct: 'ត្រឹមត្រូវ',
explanation: 'ពន្យល់',
problem: 'បញ្ហា',
do_nursing_not_published: 'ការប្រឡងកំពុងត្រូវបានធ្វើឡើងនៅក្នុងឧស្សាហកម្មថែទាំរយៈពេលយូរប៉ុន្តែសំណួរកន្លងមកមិនត្រូវបានផ្សព្វផ្សាយទេ។',
practical_exam_of_year: 'ការធ្វើតេស្តជាក់ស្តែងឆ្នាំ',
judgment_test_of_year: 'ការប្រលងវិនិច្ឆ័យឆ្នាំ ២០១៩',
judgment_test_answer_of_year: 'ចម្លើយនៃការវិនិច្ឆ័យសាលក្រមឆ្នាំ ២០១៩',
not_yet_test_material: 'មិនទាន់បានសាកល្បងនៅក្នុងឧស្សាហកម្មវត្ថុធាតុដើមនៅឡើយទេ',
not_yet_test_machinery: 'មិនទាន់ត្រូវបានសាកល្បងនៅក្នុងវិស័យផលិតកម្មគ្រឿងម៉ាស៊ីនឧស្សាហកម្មទេ',
not_yet_test_electronic: 'មិនទាន់បានសាកល្បងនៅក្នុងឧស្សាហកម្មព័ត៌មានអគ្គិសនីនិងអេឡិចត្រូនិចនៅឡើយទេ',
not_yet_test_construction: 'មិនទាន់បានសាកល្បងនៅក្នុងឧស្សាហកម្មសំណង់នៅឡើយទេ',
not_yet_test_shipbuilding: 'មិនទាន់បានសាកល្បងនៅក្នុងឧស្សាហកម្មផលិតកប៉ាល់និងសមុទ្រ',
do_automobile_not_published: 'ការប្រឡងកំពុងត្រូវបានធ្វើឡើងនៅក្នុងវិស័យថែទាំរថយន្តប៉ុន្តែសំណួរកន្លងមកមិនត្រូវបានផ្សព្វផ្សាយទេ។',
do_aviation_not_published: 'ការប្រឡងកំពុងត្រូវបានធ្វើឡើងនៅក្នុងឧស្សាហកម្មអាកាសចរណ៍ប៉ុន្តែសំណួរកន្លងមកមិនត្រូវបានផ្សព្វផ្សាយទេ។',
do_agricultural_not_published: 'ការប្រឡងកំពុងត្រូវបានធ្វើឡើងនៅក្នុងវិស័យកសិកម្មប៉ុន្តែសំណួរកន្លងមកមិនត្រូវបានផ្សព្វផ្សាយទេ។',
do_fishery_not_published: 'ការសាកល្បងកំពុងត្រូវបានធ្វើឡើងនៅក្នុងវិស័យជលផលប៉ុន្តែសំណួរកន្លងមកមិនត្រូវបានផ្សព្វផ្សាយទេ។',
do_food_not_published: 'ការប្រឡងត្រូវបានធ្វើឡើងនៅក្នុងឧស្សាហកម្មផលិតអាហារនិងភេសជ្ជៈប៉ុន្តែសំណួរកន្លងមកមិនត្រូវបានផ្សព្វផ្សាយទេ។',
do_restaurant_not_published: 'ការប្រឡងកំពុងត្រូវបានធ្វើឡើងនៅក្នុងឧស្សាហកម្មសេវាកម្មម្ហូបអាហារប៉ុន្តែសំណួរកន្លងមកមិនត្រូវបានផ្សព្វផ្សាយទេ។',
schedule_undecided: 'កាលវិភាគមិនទាន់សម្រេចចិត្ត',
year: 'ឆ្នាំ',
month: 'ខែ',
texts_learning: 'សៀវភៅសិក្សាសម្រាប់ការសិក្សានៅក្នុងឧស្សាហកម្មនីមួយៗ',
texts_learning_test: 'សៀវភៅសិក្សាសម្រាប់ការរៀនតេស្តវាយតម្លៃជំនាញជាក់លាក់ (ភាសាជប៉ុន)',
skill_test_sample: 'គំរូតេស្តវាយតម្លៃជំនាញ',
japanese_test_sample: 'គំរូតេស្តវាយតម្លៃរបស់ជប៉ុន',
not_building_texts: 'មិនទាន់មានអត្ថបទសិក្សាសម្រាប់ឧស្សាហកម្មសម្អាតអគារនៅឡើយទេ',
not_material_texts: 'មិនមានសៀវភៅសិក្សាសម្រាប់វិស័យឧស្សាហកម្មសម្ភារៈនៅឡើយទេ',
not_machinery_texts: 'មិនទាន់មានអត្ថបទសិក្សាណាមួយនៅក្នុងវិស័យផលិតគ្រឿងម៉ាស៊ីនឧស្សាហកម្មនៅឡើយទេ',
not_electronic_texts: 'មិនមានសៀវភៅសិក្សាសម្រាប់ឧស្សាហកម្មទាក់ទងនឹងអគ្គិសនីនិងព័ត៌មានអេឡិចត្រូនិចនៅឡើយទេ។',
not_shipbuilding_texts: 'មិនទាន់មានអត្ថបទសិក្សាណាសម្រាប់ផលិតនាវា / ឧស្សាហកម្មសមុទ្រនៅឡើយទេ',
not_automobile_texts: 'មិនទាន់មានសៀវភៅសិក្សាសម្រាប់ឧស្សាហកម្មថែទាំរថយន្តនៅឡើយទេ',
not_accommodation_texts: 'មិនមានសៀវភៅសិក្សាសម្រាប់ឧស្សាហកម្មស្នាក់នៅនៅឡើយទេ',
not_food_texts: 'មិនទាន់មានអត្ថបទសិក្សាសម្រាប់ផលិតកម្មអាហារនិងភេសជ្ជៈនៅឡើយទេ',
not_restaurant_texts: 'អត្ថបទសិក្សាការវាស់ស្ទង់ជំនាញនៃសេវាកម្មម្ហូបអាហារ',
each_depertment_texts: 'សៀវភៅសិក្សាសម្រាប់ការសិក្សាប្រឡងនៃផ្នែកនីមួយៗ',
skill_test_basic: 'សៀវភៅសិក្សាសាកល្បងការវាយតំលៃជំនាញ (បច្ចេកវិទ្យាមូលដ្ឋាន)',
skill_test_safety: 'អត្ថបទសិក្សាការវាយតំលៃជំនាញ (សុវត្ថិភាព / គុណភាពការងារ)',
skill_test_aircraft: 'អត្ថបទរៀនសាកល្បងការវាយតំលៃជំនាញ (ទិដ្ឋភាពទូទៅនៃយន្តហោះ)',
texts_livestock: '[សៀវភៅសិក្សាសម្រាប់ការចិញ្ចឹមសត្វ] កំណែជាភាសាជប៉ុន',
texts_cultivated: '[អត្ថបទសម្រាប់រៀនអំពីកសិកម្មដាំដុះ] ភាសាជប៉ុន',
skill_test_fishery: 'តេស្តវាស់ជំនាញជលផល (នេសាទ)',
skill_test_general_fishery: 'តេស្តវាស់ជំនាញជលផល (ជលផលទូទៅ)',
skill_test_safety_fishery: 'តេស្តវាស់ជំនាញនេសាទ (សុវត្ថិភាពជលផល)',
skill_test_specialty_fishery: 'តេស្តវាស់ជំនាញជលផល (ជំនាញជំនាញជលផល)',
skill_test_related_fishery: 'តេស្តវាស់ជំនាញជលផល (ជំនាញជំនាញនេសាទទាក់ទងនឹងការនេសាទ)',
skill_test_aquaculture: 'តេស្តវាស់ជំនាញនេសាទ (វារីវប្បកម្ម)',
skill_test_general_aquaculture: 'តេស្តវាស់ជំនាញនេសាទ (វារីវប្បកម្ម / សុវត្ថិភាពទូទៅ)',
skill_test_feeding_aquaculture: 'តេស្តវាស់ជំនាញនេសាទ (ចិញ្ចឹមនិងវារីវប្បកម្ម)',
skill_test_non_feeding_aquaculture: 'តេស្តវាស់ជំនាញនេសាទ (ទាក់ទងនឹងវារីវប្បកម្ម)',
registration_skill_visa: 'ការចុះឈ្មោះវិញ្ញាបនប័ត្រនៃការទទួលយកទិដ្ឋាការជំនាញជាក់លាក់',
please_register_pdf_number: 'សូមចុះឈ្មោះរូបថតឬឯកសារ PDF នៃលិខិតឆ្លងដែនដើម្បីទទួលបានទិដ្ឋាការជំនាញជាក់លាក់និងលេខលិខិតឆ្លងដែននៅលើវិញ្ញាបនប័ត្រលិខិតឆ្លងដែន។',
regist_and_get_cash_bag: 'ប្រសិនបើអ្នកចុះឈ្មោះឥឡូវនេះអ្នកអាចទទួលបានប្រាក់ ៥០០០ យ៉េនជាមួយនឹងកាបូបលុយ',
thank_you_regist_visa_pass: 'សូមអរគុណសម្រាប់ការចុះឈ្មោះវិញ្ញាបនប័ត្រលិខិតឆ្លងដែនសម្រាប់ការទទួលបានទិដ្ឋាការជំនាញជាក់លាក់!',
exam_info_detail: 'គ្រោងនៃការអនុវត្តតេស្ត',
em_exam_detail_language: 'ភាសាក្នុងស្រុកដែលបានគ្រោងទុក',
em_exam_detail_method: 'ការធ្វើតេស្តនាយកដ្ឋានការធ្វើតេស្តជាក់ស្តែង',
em_exam_detail_way: 'ការធ្វើតេស្តផ្អែកលើកុំព្យូទ័រ (ស៊ីប៊ីធី) វិធីសាស្ត្រសាកល្បងក្រដាសឬវិធីសាស្ត្រសាកល្បងការងារដូចជាផលិតកម្ម',
em_exam_detail_section: '១៩ ប្រភេទនៃការធ្វើតេស្ត (ការបោះ, ក្លែងបន្លំ, វណ្ណះងាប់, គ្រឿងម៉ាស៊ីន, ដែកថែប, ដែក, សន្លឹកដែករោងចក្រ, ផ្លាស្ទិច, អាណូអាលុយមីញ៉ូម, បញ្ចប់, ការត្រួតពិនិត្យមេកានិច, ការថែរក្សាម៉ាស៊ីន, ការដំឡើងឧបករណ៍អេឡិចត្រូនិច, ការជួបប្រជុំគ្នាឧបករណ៍អគ្គិសនី, ការផលិតបន្ទះដែកបោះពុម្ព, ប្លាស្ទិកប្លាស្ទិក ថ្នាំលាបផ្សារដែកវេចខ្ចប់ឧស្សាហកម្ម)',
em_exam_detail_notify: 'បន្ទាប់ពីការធ្វើតេស្តសូមផ្ញើការជូនដំណឹងលទ្ធផលតាមអ៊ីមែល',
em_exam_detail_border: 'ការធ្វើតេស្ដរបស់មន្ទីរ៖ ៦៥% ឬច្រើនជាងនេះការធ្វើតេស្តជាក់ស្តែង៖ ៦០ ពិន្ទុឬច្រើនជាងនេះ',
ss_exam_detail_language: 'ភាសាជប៉ុន',
ss_exam_detail_method: 'ការធ្វើតេស្តសមត្ថភាពត្រូវបានធ្វើឡើងដោយការធ្វើតេស្តជាក់ស្តែងនិងការធ្វើតេស្តមន្ទីរ។ ការប្រឡងអនុវត្តជាក់ស្តែងត្រូវបានធ្វើឡើងសម្រាប់ប្រភេទអាជីវកម្មនីមួយៗ។ ការធ្វើតេស្តនាយកដ្ឋានត្រូវបានធ្វើឡើងសម្រាប់ប្រភេទអាជីវកម្មនីមួយៗដោយវិធីសាស្ត្រសាកល្បងក្រដាស។',
ss_exam_detail_way: 'វិធីសាស្ត្រធ្វើតេស្តក្រដាស។ ល។',
ss_exam_detail_section: 'នាយកដ្ឋាន / ជំនាញអនុវត្តជាក់ស្តែង / ជំនាញ: ការផ្សារដែកគំនូរការធ្វើដែកការបញ្ចប់គ្រឿងម៉ាស៊ីនការដំឡើងឧបករណ៍អគ្គិសនី',
ss_exam_detail_notify: '',
ss_exam_detail_border: 'ការធ្វើតេស្តិ៍នាយកដ្ឋាន៖ ៦០% ឬច្រើនជាងនេះការធ្វើតេស្ដជាក់ស្តែង៖ ការវិនិច្ឆ័យផ្អែកលើលទ្ធផលជាក់ស្តែង',
c_exam_detail_language: 'ភាសាជប៉ុន',
c_exam_detail_method: 'ការធ្វើតេស្តសមត្ថភាពត្រូវបានធ្វើឡើងដោយការធ្វើតេស្តជាក់ស្តែងនិងការធ្វើតេស្តមន្ទីរ។',
c_exam_detail_way: 'ការធ្វើតេស្តផ្អែកលើកុំព្យូទ័រ (ស៊ីប៊ីធី) ការធ្វើតេស្តជាក់ស្តែងគឺជាវិធីសាស្ត្រដែលបានបញ្ជាក់ដោយសាជីវកម្មដែលបានចុះឈ្មោះ',
c_exam_detail_section: '',
c_exam_detail_notify: 'ផ្សាយលើគេហទំព័រ',
c_exam_detail_border: 'ការធ្វើតេស្តិ៍មន្ទីរ៖ ៦៥% ឬច្រើនជាងនេះការធ្វើតេស្ដជាក់ស្តែង៖ ការវិនិច្ឆ័យផ្អែកលើលទ្ធផលជាក់ស្តែង',
cm_exam_detail_language: 'ភាសាជប៉ុន',
cm_exam_detail_method: 'ការធ្វើតេស្តសមត្ថភាពត្រូវបានធ្វើឡើងដោយការធ្វើតេស្តជាក់ស្តែងនិងការធ្វើតេស្តមន្ទីរ។',
cm_exam_detail_way: 'អនុវត្តការប្រឡងផ្នែកសិក្សានិងអនុវត្តជាក់ស្តែងដោយតេស្តកុំព្យូទ័រ (ស៊ីប៊ីធី)',
cm_exam_detail_section: 'មុខវិជ្ជានៃការប្រឡងមុខវិជ្ជា ។ ចំណេះដឹងបឋមអំពីរចនាសម្ព័នមុខងារនិងវិធីដោះស្រាយក។ ចំណេះដឹងបឋមអំពីការត្រួតពិនិត្យជួសជុលនិងកែសំរួលគ។ លក្ខណៈសម្បត្តិនិងការប្រើប្រាស់មុខវិជ្ជាសាកល្បងជាក់ស្តែងក។ ការងារមូលដ្ឋានសាមញ្ញក។ ការរុះរើការជួបប្រជុំការត្រួតពិនិត្យនិងការកែសំរួលគ។ ការជួសជុលងាយៗឃ។ ការកាន់ងាយស្រួលនៃម៉ាស៊ីនសាកល្បងឧបករណ៍វាស់ស្ទង់និងឧបករណ៍ដើម្បីងាយស្រួលក្នុងការថែទាំ។',
cm_exam_detail_notify: '',
cm_exam_detail_border: 'ការធ្វើតេស្តិ៍នៅមន្ទីរ៖ ៦៥% ឬច្រើនជាងនេះការធ្វើតេស្ដជាក់ស្តែង៖ ពិន្ទុសរុប ៦០% ឬលើសនេះ',
a_exam_detail_language: 'ភាសាក្នុងស្រុកនិងជប៉ុន',
a_exam_detail_way: 'ការធ្វើតេស្តផ្អែកលើកុំព្យូទ័រ (ស៊ីប៊ីធី) វិធីសាស្ត្រសាកល្បងក្រដាស',
a_exam_detail_section: '①នាយកដ្ឋានដាំដុះកសិកម្មជាទូទៅសុវត្ថិភាពនិងសុខភាពពូជ / លក្ខណៈនៃដំណាំដាំដុះបរិស្ថានដាំដុះ (កន្លែង / ឧបករណ៍ / វត្ថុធាតុដើម / គ្រឿងម៉ាស៊ីន) វិធីសាស្រ្តដាំដុះ / ការគ្រប់គ្រងការកំចាត់សត្វល្អិត / ស្មៅការប្រមូលផល / ការកែសំរួល / ការផ្ទុក / ការដឹកជញ្ចូន ការសង្កេតដី ការគ្រប់គ្រងជី / ថ្នាំសំលាប់សត្វល្អិតការគ្រប់គ្រងគ្រាប់ពូជការគ្រប់គ្រងបរិស្ថានការគ្រប់គ្រងសម្ភារៈ / ឧបករណ៍ / ម៉ាស៊ីនការងារទាក់ទងនឹងការដាំដុះសុវត្ថិភាពនិងសុខភាព③ជនជាតិជប៉ុនស្ដាប់ ខ្លឹមសារនៃការងារកសិកម្មណែនាំជាភាសាជប៉ុន',
a_exam_detail_notify: 'ផ្សាយលើគេហទំព័រ',
a_exam_detail_border: 'ពិន្ទុសរុបលើសពីចំណុចយោងនៃការវិនិច្ឆ័យដែលកំណត់ដោយសភាពាណិជ្ជកម្មជាតិ។',
avi_exam_detail_method: 'ការធ្វើតេស្តសមត្ថភាពត្រូវបានធ្វើឡើងដោយការធ្វើតេស្តជាក់ស្តែងនិងការធ្វើតេស្តមន្ទីរ។',
avi_exam_detail_section: 'សំណួរនឹងត្រូវបានផ្តល់ជូនពីអត្ថបទដែលបានផ្សាយនៅលើគេហទំព័ររបស់សមាគមបច្ចេកវិទ្យាអាកាសចរណ៍ជប៉ុន។ ការសន្និដ្ឋានជំនាញជាក់ស្តែងការវាស់អគ្គិសនី',
avi_exam_detail_notify: '',
avi_exam_detail_border: 'ការធ្វើតេស្តិ៍នៅមន្ទីរ៖ ៦៥% ឬច្រើនជាងនេះការធ្វើតេស្ដជាក់ស្តែង៖ ពិន្ទុសរុប ៦៥% ឬលើសនេះ',
f_exam_detail_language: 'ភាសាជប៉ុន',
f_exam_detail_method: 'ការធ្វើតេស្តសមត្ថភាពត្រូវបានធ្វើឡើងដោយការធ្វើតេស្តជាក់ស្តែងនិងការធ្វើតេស្តមន្ទីរ។',
f_exam_detail_way: 'អនុវត្តការប្រឡងផ្នែកសិក្សានិងអនុវត្តជាក់ស្តែងដោយតេស្តកុំព្យូទ័រ (ស៊ីប៊ីធី)',
f_exam_detail_section: 'មុខវិជ្ជាតេស្តត្រូវបញ្ជាក់ថាកំរិតជាក់លាក់នៃការងារក្នុងវិស័យជលផល (ជលផល) ឬវាលជលផល (វារីវប្បកម្ម) អាចត្រូវបានអនុវត្តយ៉ាងត្រឹមត្រូវដោយការយល់ដឹងពីការណែនាំរបស់អ្នកត្រួតពិនិត្យរឺអាចអនុវត្តតាមការសំរេចចិត្តរបស់ខ្លួនហើយគ្រាន់តែជាជំនាញ វាមិនមែនជាការវាយតម្លៃអំពីវត្តមានឬអវត្តមាននៃចំណេះដឹងនោះទេប៉ុន្តែវាក៏អាចវាយតម្លៃវត្តមានឬអវត្តមាននៃការវិនិច្ឆ័យត្រឹមត្រូវនិងចំណេះដឹងការងារដែលចាំបាច់សម្រាប់អនុវត្តការងារនៅក្នុងវិស័យជលផល (នេសាទ) ឬវាលនេសាទ (វារីវប្បកម្ម) ។',
f_exam_detail_notify: 'ផ្សាយលើគេហទំព័រ',
f_exam_detail_border: 'អ្នកដែលមានពិន្ទុសរុបនៃការសរសេរជាលាយលក្ខណ៍អក្សរនិងតេស្តជាក់ស្តែងលើសពីពិន្ទុស្តង់ដារវិនិច្ឆ័យដែលកំណត់ដោយទីភ្នាក់ងារប្រតិបត្តិតេស្តសមត្ថភាពត្រូវបានទទួលយក។',
no_exam_info: 'មិនទាន់មានព័ត៌មានសង្ខេបនៃការសាកល្បងត្រូវបានចេញផ្សាយនៅឡើយទេ',
language: 'ភាសាកាអនុវត្ត',
method: 'វិធីសាស្ត្រអនុវត្ត',
way: 'វិធីសាស្ត្រអនុវត្ត',
section: 'ប្រភេទតេស្ត',
notify: 'ការជូនដំណឹងអំពីលទ្ធផលតេស្ត',
border: 'លក្ខណៈវិនិច្ឆ័យលទ្ធផលតេស្ត',
go_line_at: 'ទៅកាន់ឡាញ',
thank_you_and_deactivate: 'សូមអរគុណ សម្រាប់នីតិវិធីដកប្រាក់ពីសេវាកម្មសូមបញ្ចូលនីតិវិធីដកប្រាក់ពីបន្ទាត់ ផ្ដល់ពត៏មាន ខាងក្រោម។ ដើម្បីលុបចោលការទូទាត់ទៀងទាត់សូមបញ្ចូលការលុបចោលការទូទាត់ធម្មតាពីបន្ទាត់ ផ្ដល់ពត៏មាន ខាងក្រោម។ យើងនឹងអនុវត្តនីតិវិធីនៅពេលយើងទទួលបានការបញ្ជាក់',
thank_you_and_subscribe: 'សូមអរគុណចំពោះការប្រើប្រាស់។ n សម្រាប់ការលុបចោលការបង់ប្រាក់ជាប្រចាំសូមបញ្ចូលការលុបចោលការទូទាត់ធម្មតាពីបង្អួច @ line ខាងក្រោម។ n យើងនឹងលុបចោលកិច្ចសន្យាភ្លាមៗនៅពេលយើងទទួលបានការបញ្ជាក់។',
ten_thousand_yen: 'មួយម៉ឺនយ៉េន',
yen_per_month: 'យ៉េនក្នុងមួយខែ',
how_to_use_this_service: 'លំហូរនៃការប្រើប្រាស់',
selecting_a_browser: 'ការជ្រើសរើសកម្មវិធីរុករក',
selecting_a_browser_dec: 'ចូលប្រើ https://aelu.co.jp ជាមួយកម្មវិធីបើកអ៊ីនធឺណិត (Google chrome, Safari, Edge។ ល។ ) * គ្មានកម្មវិធីទេ',
provisional_registration: 'ការចុះឈ្មោះបណ្តោះអាសន្ន',
provisional_registration_dec: 'ចូលជាមួយហ្វេសប៊ុកឬហ្គូហ្គោលរបស់អ្នកឬចុះឈ្មោះជាមួយអាសយដ្ឋានអ៊ីមែលរបស់អ្នក។ បន្ទាប់ពីជ្រើសរើសភាសានិងមុខរបរដែលអ្នកចង់បានអ្នកអាចរកមើលមាតិកាក្លែងក្លាយនៃការប្រឡងវិញ្ញាបនប័ត្រអ៊ីនធឺណិត។',
full_registration: 'ការចុះឈ្មោះសំខាន់',
full_registration_dec: 'ចុច "ចុះឈ្មោះ" នៅលើទំព័រមាតិកានៃការប្រឡងវិញ្ញាបនប័ត្រតាមអ៊ិនធឺរណែតបំពេញព័ត៌មានដែលត្រូវការហើយប្រើសេវាកម្មទាំងអស់រួមទាំងសំណួរនៃការអនុវត្តការប្រឡងវិញ្ញាបនប័ត្រឧស្សាហកម្មចំនួន ១៤ ។',
name_validate_message: 'សូមបញ្ចូលព័ត៌មានដែលមានអក្ខរាវិរុទ្ធដូចគ្នានៅពេលវាបង្ហាញលើលិខិតឆ្លងដែនរបស់អ្នក',
live_at_area: 'តំបន់ដែលអ្នករស់នៅ',
agency_application: 'ធ្វើពាក្យសុំប្រឡង',
mypage: 'ទំព័ររបស់ខ្ញុំ',
myanmar: 'ភាសាមីយ៉ាន់ម៉ា',
exam_list: 'បញ្ជីកាលវិភាគប្រឡង',
no: 'ទី',
times: 'ចំនួនដង',
application_start: 'ចាប់ផ្ដើមដាក់ពាក្យ',
application_end: 'ការដាក់ពាក្យត្រូវបានបញ្ចប់',
enforcement: 'ការអនុវត្ត',
applicated: 'អនុវត្ត​',
reception_time: 'ពេលវេលាទទួលភ្ញៀវ',
announthment_d: 'កាលបរិច្ឆេទនៃការប្រកាសទទួលយក',
reception_period: 'រយៈពេលដាក់ពាក្យសុំ',
detail_link: 'មើលព័ត៌មានលម្អិត',
exam_country: 'ប្រទេស​ម្ចាស់ផ្ទះ',
line: 'LINE',
vietnum: 'វៀតណាម',
laos: 'ឡាវ',
malaysia: 'ម៉ាឡេស៊ី',
bangladesh: 'បង់ក្លាដេស',
indo: 'ឥណ្ឌា',
nepal: 'ណេប៉ាល់',
mongol: 'ម៉ុងហ្គោល',
indonesia: 'ឥណ្ដូនេស៊ី',
th: 'ថៃ',
philipine: 'ភីលីពីន',
my: 'មីយ៉ាន់ម៉ា',
uzbekistan: 'អ៊ូសបេគីស្ថាន',
pakistan: 'ប៉ាគីស្ថាន',
japan: 'ជប៉ុន',
news_title: 'ព័ត៌មានអំពីទិដ្ឋាការជំនាញជាក់លាក់',
missNowPassword: 'លេខសំងាត់បច្ចុប្បន្នមិនត្រឹមត្រូវ',
article6_sub2_dec2: 'ប្រសិនបើអ្នកដាក់ពាក្យនៅទីនេះយើងក៏នឹងប្រកាសពាក្យសុំសាកល្បងតម្លៃសាកល្បងនិងទីកន្លែងរហូតដល់ថ្ងៃប្រលង។',
create_naw_password: 'ផ្លាស់ប្ដូរលេខកូត',
send_confirmcode: 'លេខកូដផ្ទៀងផ្ទាត់ត្រូវបានផ្ញើ',
edit: 'ផ្លាស់ប្ដូរ',
success_new_password_setting: 'អ្នកបានកំណត់លេខសំងាត់ថ្មី។',
error_email: 'នេះគឺជាអាសយដ្ឋានអ៊ីមែលដែលមិនបានចុះឈ្មោះ។',

click_here_businesses: "ចុចត្រង់នេះសំរាប់អាជីវកម្ម",
regist_organization_staff_info: "ការចុះឈ្មោះព័ត៌មានអាជីវកម្ម / អ្នកប្រើប្រាស់",
organization_info: "ព័ត៌មានអាជីវកម្ម",
staff_info: "ព័ត៌មានអ្នកប្រើប្រាស់",
org_name: "ឈ្មោះ​អាជីវកម្ម",
url: "URL",
org_scale: "ជញ្ជីង",
org_zip: "លេខ​កូដ​ប្រៃ​ស​ណី​យ",
org_adress1: "អាណាខេត្ត",
org_adress2: "ក្រុង",
org_adress3: "អាសយដ្ឋាន / ឈ្មោះអាផាតមិន",
org_industry: "ឧស្សាហកម្ម",
org_category: "ប្រភេទ",
org_description: "ការពិពណ៌នា",
org_established_at: "ឆ្នាំបង្កើត",
org_phone: "លេខទូរស័ព្ទជំនួញ",
failed_established_at: "កាលបរិច្ឆេទមិនត្រឹមត្រូវ។",
staff_name: "ឈ្មោះ​អ្នកប្រើប្រាស់",
form_miss: "មានកំហុសក្នុងទម្រង់បញ្ចូល។",
back_joboffer_detail: "ត្រឡប់ទៅព័ត៌មានលំអិតការងារ <",
create_joboffer: "បង្កើតការងារ",
edit_joboffer: "កែសម្រួលការងារ",
stop_posting: "បញ្ឈប់ការចុះផ្សាយ",
delete: "លុប",
job_title: "ចំណងជើងការងារ",
job_catch_phrase: "ឃ្លាចាប់ការងារ",
job_category: "ប្រភេទមុខរបរ",
employed_company_name: "ឈ្មោះក្រុមហ៊ុនដែលបានជួល",
work_location: "ទីតាំងការងារ",
employment_status: "ស្ថានភាពការងារ",
full_time_employee: "បុគ្គលិកពេញម៉ោង",
part_time_job: "ការងារ​ក្រៅ​ម៉ោង",
temporary_staff: "ពលកម្មផ្តាច់",
contract_employee: "បុគ្គលិកកិច្ចសន្យា",
intern: "អ្នកហាត់ការ",
subcontracting: "ការចុះកិច្ចសន្យាបន្ត",
contract: "កិច្ចសន្យា",
new_graduate: "និស្សិតទើបបញ្ចប់ការសិក្សា",
salary: "ប្រាក់ខែ",
annual_income: "ចំ​នូ​ល​ប្រចាំឆ្នាំ",
monthly_salary: "ប្រាក់ខែ",
weekly_salary: "ប្រាក់ខែប្រចាំសប្តាហ៍",
dayly_salary: "ប្រាក់ខែប្រចាំថ្ងៃ",
job_offer_attension1: "វាចាំបាច់ក្នុងការចង្អុលបង្ហាញយ៉ាងច្បាស់ពីល័ក្ខខ័ណ្ឌការងារដែលបានកំនត់។ ល។ សម្រាប់ខ្លឹមសារការងារស្របតាមច្បាប់។",
job_offer_attension2: "សូមពិនិត្យមើលល័ក្ខខ័ណ្ឌការងារ។ ល។ ដែលតម្រូវឱ្យមានការបញ្ជាក់ច្បាស់តាមច្បាប់ហើយបន្ទាប់មកពិពណ៌នាខ្លឹមសារការងារ។ (ឯកសារយោង៖ ក្រសួងសុខាភិបាលការងារនិងសុខុមាលភាពការិយាល័យការងារខេត្ត &quot;ដល់ក្រុមហ៊ុនទាំងអស់ដែលជ្រើសរើសកម្មករ&quot;)",
job_offer_attension3: "ការងារមិនត្រូវបានចុះផ្សាយទេប្រសិនបើអ្នកប្រើភាសាដែលកំណត់អាយុភេទឬស្ថានភាពសង្គមរបស់មនុស្សគោលដៅ។",
job_offer_attension4: "ឧទាហរណ៍ដែលមិនបានផ្សព្វផ្សាយជាញឹកញាប់៖ &quot;ស្វាគមន៍ដល់អាយុ ២០ ឆ្នាំ&quot; &quot;សូមស្វាគមន៍ចំពោះយុវជន (យុវជន)&quot; &quot;ស្ត្រីស្វាគមន៍ / មានកំណត់&quot; &quot;តែនិស្សិត&quot;",
work_content_appeal: "មាតិកាការងារនិងចំណុចបណ្តឹងឧទ្ធរណ៍",
work_content_appeal_desc: "វានឹងងាយស្រួលសម្រាប់អ្នកស្វែងរកការងារធ្វើប្រសិនបើអ្នកប្រាប់ពួកគេពីចំណុចប្តឹងឧទ្ធរណ៍ជាមុន។",
human_resources_seek: "ធនធានមនុស្ស",
human_resources_seek_desc: "ចូរបង្ហាញមិនត្រឹមតែជំនាញដែលអ្នកកំពុងស្វែងរកប៉ុណ្ណោះទេប៉ុន្តែថែមទាំងព័ត៌មានដែលអនុញ្ញាតឱ្យអ្នកស្វែងរកការងារស្រមៃពីកន្លែងធ្វើការ។",
working_hours: "ម៉ោង​ធ្វើការ",
traffic_access: "ការចូលចរាចរ",
traffic_access_desc: "ក្រៅពីព័ត៌មានស្តីពីមធ្យោបាយធ្វើដំណើរសាធារណៈរួមមានព័ត៌មានដូចជាការធ្វើដំណើរតាមរថយន្តនិងថាតើមានចំណតរថយន្តសម្រាប់និយោជិកដែរឬទេ។",
required: "ចាំបាច់",
optional: "ណាមួយ",
other: "ផ្សេងទៀត",
photo: "រូបថត",
upload_video: "ផ្ទុកវីដេអូឡើង",
job_tag: "ស្លាកការងារ",
until_select_three: "អាចជ្រើសរើសរហូតដល់ ៣ នាក់",
senior_support: "ការគាំទ្រជាន់ខ្ពស់",
salary_increase_promotion: "មានការតម្លើងប្រាក់ខែ / ការផ្សព្វផ្សាយ",
no_overtime: "គ្មានការថែមម៉ោង",
target_hiring_time: "កំណត់ពេលវេលាជួលគោលដៅ",
additional_questions: "សំណួរបន្ថែម",
job_offer_title: "ឈ្មោះការងារ",
public: "ការដោះលែង",
private: "ឯកជន",
public_status: "ស្ថានភាពសាធារណៈ",
occupation: "មុខរបរ",
walfare: "ការព្យាបាល / សុខុមាលភាព",
create: "បង្កើត",
hour: "ពេលវេលា",
back_mypage: "ត្រឡប់ទៅទំព័ររបស់ខ្ញុំ <",
job_offers: "ការចុះបញ្ជីការងារ",
look_matches: "មើលបញ្ជីការប្រកួត",
now_public: "ឥឡូវបើកហើយ",
now_private: "ឯកជន",
check: "បញ្ជាក់",
edit2: "ដើម្បីកែសម្រួល",
news_detail: "ព័ត៌មានលម្អិត",
prefectures: "អាណាខេត្ត",
hokkaido: "ហុកកាដូ",
aomori: "អាម៉ូរី",
iwate: "អ៊ីវ៉ាត",
miyagi: "មីយ៉ាហ្គី",
akita: "អាគីតា",
yamagata: "យ៉ាម៉ាហ្គាតា",
fukushima: "ហ្វូគូស៊ីម៉ា",
ibaraki: "អ៊ីបារ៉ាគី",
tochigi: "តូឈីជី",
gunma: "ហ្គាំម៉ា",
saitama: "សៃតាម៉ា",
chiba: "ឈីបា",
tokyo: "តូក្យូ",
kanagawa: "កាណាហ្គាវ៉ា",
niigata: "នីកាតាតា",
toyama: "តូតាម៉ា",
ishikawa: "អ៊ីស៊ីកាវ៉ា",
fukui: "ហ្វូគូ",
yamanashi: "Yamanashi",
nagano: "ណាហ្គាណូ",
gifu: "ហ្គីហ្វូ",
shizuoka: "ហ្សីហ្សូកា",
aichi: "អាឈី",
mie: "បីដង",
shiga: "ស៊ីហ្គា",
kyoto: "ក្យូតូ",
osaka: "អូសាកា",
hyogo: "ហ៊ីហ្គូហ្គោ",
nara: "ណារ៉ា",
wakayama: "វ៉ាកាយ៉ាម៉ា",
tottori: "តូតូរី",
shimane: "Shimane",
okayama: "អូកាយ៉ាម៉ា",
hiroshima: "ហ៊ីរ៉ូស៊ីម៉ា",
yamaguti: "Yamaguchi",
tokushima: "តូគូស៊ីម៉ា",
kagawa: "កាហ្គាវ៉ា",
echime: "អ៊ីហីម",
kochi: "កូជី",
fukuoka: "ហ្វូគូគូ",
saga: "សាកា",
nagasaki: "ណាហ្គាសាគី",
kumamoto: "គូម៉ាម៉ូតូ",
oita: "អូតា",
miyazaki: "មីយ៉ាហ្សាគី",
kagoshima: "កាហ្គាស៊ីម៉ា",
okinawa: "អូគីណាវ៉ា",
sinhalese: "ស៊ីនហាឡា",
exam_region: "អាណាខេត្ត",
exam_place_list: "បញ្ជីទីកន្លែង",
exam_place_name: "ឈ្មោះកន្លែងប្រឡង",
care_evaluation_test: "ការធ្វើតេស្តវាយតម្លៃការបណ្តុះបណ្តាលជំនាញថែទាំរយៈពេលវែង",
clean_building_test: "ឧស្សាហកម្មសម្អាតអគារមានបញ្ហាកន្លងមក",
answer: "ចម្លើយ",
skill_test_measurement: "តេស្តវាស់ជំនាញ",
exam_problem: "សំណួរនៃការប្រឡង",
fields: "វាលស្រែនិងបន្លែ",
gardening: "ថែសួនងាយស្រួល",
mushroom: "ផ្សិត",
fruit: "ដើមឈើហូបផ្លែ",
dairy: "ទឹកដោះគោ",
poultry: "កសិកម្មបសុបក្សី",
pig: "ការចិញ្ចឹមជ្រូក",
beginner: "អ្នកចាប់ផ្តើមដំបូង",
professional: "ថ្នាក់វិជ្ជាជីវៈ",
advanced: "កម្រិតខ្ពស់",
technical_training_test: "តេស្តវាយតម្លៃការបណ្តុះបណ្តាលអ្នកហាត់ការបច្ចេកទេស",
exam_part: "ផ្នែកនៃសំណួរប្រឡង",
tokoha_fruit: "មែកធាងផ្លែឈើតូកូហា",
deciduous_fruit: "ដើមឈើហូបផ្លែ",
ver: "បោះពុម្ព",
errata: "errata",
form_work: "សំណង់ទម្រង់",
construction: "អ្នកធ្វើផែនការ",
tunnel_line: "ខ្សែរុញច្រានធ្យូនែល",
earth_work: "ការងារលើផែនដី",
loofing: "ដំបូល",
elecommunication: "ទូរគមនាគមន៍",
reinforcing_contstruction: "ពង្រឹងការសាងសង់របារ",
reinforcing_joint: "ពង្រឹងរបាររួមគ្នា",
wall_painting: "គំនូរ (គ្របលើជញ្ជាំង)",
board_finish: "ការបញ្ចប់ក្តារបញ្ចប់ផ្ទៃខាងក្នុង",
steeplejack: "លោត",
spray_insulation: "អ៊ីសូឡង់កំដៅ urethane",
marine_civil: "វិស្វកម្មស៊ីវិលសមុទ្រ",
concrete_pumping: "ការបូមបេតុង",
construction_machinery: "សំណង់គ្រឿងម៉ាស៊ីនសំណង់",
learning_text: "ការរៀនអត្ថបទ",
basic_aircraft: "ការសន្និដ្ឋានបច្ចេកវិទ្យាមូលដ្ឋានយន្តហោះការវាស់អគ្គិសនី",
worksafety_quality: "សុវត្ថិភាពការងារគុណភាព",
aircraft_overview: "ទិដ្ឋភាពទូទៅនៃយន្តហោះ",
fish_general: "ជលផលជាទូទៅ",
fish_safety: "សុវត្ថិភាពជលផល",
network_relations: "ទំនាក់ទំនងខ្សែពួរជំនាញនេសាទ",
fish_relations: "ជំនាញនេសាទទាក់ទងនឹងការនេសាទ",
aquaculture_general: "វារីវប្បកម្មជាទូទៅ",
feeding_aquaculture: "ជំនាញវារីវប្បកម្មចិញ្ចឹមវារីវប្បកម្ម",
unfed_aquaculture: "វារីវប្បកម្មឯកទេសវារីវប្បកម្មវារីវប្បកម្ម",
attachment: "ឯកសារ​ភ្ជាប់",
glossary: "សទ្ទានុក្រម",
feneral_customer: "សេវាកម្មអតិថិជនទូទៅ",
food_dring_cooking: "អាហារនិងភេសជ្ជៈចម្អិនអាហារ",
hygiene_management: "ការគ្រប់គ្រងអនាម័យ",
visa_application: "ពាក្យសុំទិដ្ឋាការជំនាញជាក់លាក់",
certificate_residence_tax: "លិខិតបញ្ជាក់ពន្ធលើប័ណ្ណស្នាក់នៅ (សម្រាប់ឆ្នាំចុងក្រោយ)",
salary_income_withholding : "២- ច្បាប់ថតចម្លងដកហូតមួយច្បាប់សម្រាប់ចំណូលប្រាក់ខែ",
national_health_insured: "3. ច្បាប់ថតចំលងប័ណ្ណធានារ៉ាប់រងសុខភាពថ្នាក់ជាតិ (ប្រសិនបើបុគ្គលនោះចុះឈ្មោះ)",
national_health_payment: "វិញ្ញាបនប័ត្រទូទាត់បុព្វលាភរ៉ាប់រងសុខភាពថ្នាក់ជាតិ",
national_health_receipt: "៥- ច្បាប់ថតចម្លងវិក្កយបត្រធានារ៉ាប់រងសុខភាពជាតិ",
technical_intern_training2: "ឯកសារបញ្ជាក់ថាការបណ្តុះបណ្តាលកម្មសិក្សាបច្ចេកទេសលេខ ២ បានបញ្ចប់ដោយជោគជ័យ",
need_the_following : "អ្នកត្រូវការមួយដូចខាងក្រោមៈ",
pass_certificate_test_specialized : "copy ច្បាប់ថតចម្លងលិខិតបញ្ជាក់ការប្រលងជំនាញជាក់ស្តែងនៃការប្រលងវាយតម្លៃជំនាញ (ថ្នាក់ជំនាញ)",
technical_intern_training3: "copy ច្បាប់ថតចម្លងលិខិតបញ្ជាក់ការប្រលងជាក់ស្តែងនៃការប្រលងជំនាញ (ថ្នាក់ទី ៣)",
evaluation_record_technical_intern: "・ ប្រសិនបើអ្នកមិនបានប្រឡងជាប់ខាងលើទេអ្នកត្រូវបំពេញកំណត់ត្រាវាយតម្លៃសម្រាប់អ្នកហាត់ការបច្ចេកទេស។",
cartificate_pass_basic_test: "ជាជំរើសមួយសំរាប់ ៧.៦ អ្នកអាចផ្ញើច្បាប់ថតចម្លងវិញ្ញាបនប័ត្រលិខិតឆ្លងដែនរបស់មូលនិធិជប៉ុនមូលនិធិជប៉ុនរឺច្បាប់ថតចម្លងវិញ្ញាបនប័ត្រលិខិតឆ្លងដែននៃការប្រលងសមត្ថភាពភាសាជប៉ុន (N4) រឺខ្ពស់ជាងនេះ។",
change_permission_application: "8. រូបថតនៃពាក្យសុំការអនុញ្ញាតផ្លាស់ប្តូរ (បញ្ឈរ ៤ ស។ ម។ ផ្ដេក ៣ ស។ ម។ )",
resume_data_time_entry: "9. បន្តទិន្នន័យនៅពេលចូល",
select_file: "ជ្រើសរើសឯកសារ",

description_movie: "វីដេអូពន្យល់",
how_to_use_movie: "របៀបប្រើវីដេអូ",
movie_news: "ព័ត៌មានអំពីទិដ្ឋាការជំនាញជាក់លាក់",
movie_exam: "2. ចំនួនថ្ងៃនៅសល់រហូតដល់កាលបរិច្ឆេទសាកល្បង",
movie_predict_pass: "អត្រាអត្រាប៉ាន់ស្មាន",
movie_ave_study_test: "ពិន្ទុមធ្យមនៃការធ្វើតេស្តផ្ទាល់ខ្លួនដែលអ្នកបានសិក្សា",
movie_similar_exam: "សំណួរប្រឡងស្រដៀងគ្នា",
movie_learning_text: "ទាញយកសៀវភៅសិក្សា (សៀវភៅសិក្សា)",
movie_solved_exam: "បញ្ហាដែលខ្ញុំបានដោះស្រាយកាលពីអតីតកាល",
movie_pased_exam: "8. អំពីការមើលឃើញបញ្ហាពីអតីតកាលដែលពិតជាបានលេចឡើង",
movie_resume_regist: "9. បន្តការចុះឈ្មោះនៅពេលចូល",
movie_pass_document_regist: "10. ការចុះឈ្មោះប្រឡងតេស្តសមត្ថភាព",
movie_agency_service: "សេវាកម្មទីភ្នាក់ងារដាក់ពាក្យប្រឡង",
movie_consule_service: "សេវាកម្មពិគ្រោះយោបល់រៀន",
description_movie_trans: "ប្រសិនបើអ្នកចង់មើលជាភាសាក្រៅពីភាសាជប៉ុនសូមចុចលើប្រអប់លេខចុចចំណងជើងរងនិងការបកប្រែដោយស្វ័យប្រវត្តិជ្រើសរើសភាសាកំណើតរបស់អ្នកហើយបន្ទាប់មកមើល។",
"cultivated_agriculture_general": "កសិកម្មដាំដុះជាទូទៅ",
"livestock_agriculture": "កសិកម្មចិញ្ចឹមសត្វ",
"介護": "ថែទាំ",
"ビルクリーニング": "ការសម្អាតអគារ",
"建設": "សំណង់",
"自動車整備": "ការថែទាំរថយន្ត",
"航空業": "ឧស្សាហកម្មអាកាសចរណ៍",
"農業": "កសិកម្ម",
"漁業": "ការនេសាទ",
"飲食料品製造業": "ឧស្សាហកម្មផលិតអាហារ និងភេសជ្ជៈ",
"外食業": "អាជីវកម្មភោជនីយដ្ឋាន",
"型枠施工": "ការសាងសង់ទម្រង់",
"左官": "ជាងម្នាងសិលា",
"コンクリート圧送": "ការបូមបេតុង",
"トンネル推進工": "ការងារជំរុញផ្លូវរូងក្រោមដី",
"建設機械施工": "ការសាងសង់គ្រឿងចក្រសំណង់",
"大工": "ជាងឈើ",
"屋根ふき": "ដំបូល",
"電気通信": "ទូរគមនាគមន៍",
"鉄筋施工": "ការពង្រឹងការសាងសង់របារ",
"鉄筋継手": "ការពង្រឹងសន្លាក់របារ",
"壁装（壁張り）": "គម្របជញ្ជាំង (ជញ្ជាំង)",
"ボード仕上げ、内装仕上げ": "ការបញ្ចប់ក្តារ, ផ្ទៃខាងក្នុង",
"とび": "លោត",
"吹き付けウレタン断熱": "បាញ់អ៊ីសូឡង់បាញ់",
"海洋土木工": "វិស្វកម្មស៊ីវិលសមុទ្រ",
"航空機の基本技術 締結、電気計測": "ការសន្និដ្ឋានបច្ចេកវិទ្យាមូលដ្ឋានយន្តហោះ ការវាស់វែងអគ្គិសនី",
"作業安全、品質": "សុវត្ថិភាពការងារ គុណភាព",
"航空機概要": "ទិដ្ឋភាពទូទៅនៃយន្តហោះ",
"耕種農業全般": "កសិកម្មដាំដុះជាទូទៅ",
"畜産農業": "កសិកម្មចិញ្ចឹមសត្វ",
"漁業一般": "ការនេសាទជាទូទៅ",
"漁業安全": "សុវត្ថិភាពជលផល",
"漁業専門 綱関係": "ទំនាក់ទំនងខ្សែពួរ ជំនាញជលផល",
"漁業専門 釣り関係": "ជំនាញក្នុងការនេសាទទាក់ទងនឹងការនេសាទ",
"養殖業一般": "ជាទូទៅវារីវប្បកម្ម",
"養殖業専門 給餌養殖関係": "ជំនាញវារីវប្បកម្ម ការចិញ្ចឹមវារីវប្បកម្ម",
"養殖業専門 無給餌養殖関係": "ជំនាញវារីវប្បកម្ម Unfed វារីវប្បកម្ម",
"接客全般": "សេវាកម្មអតិថិជនទូទៅ",
"飲食物調理": "ចម្អិនអាហារនិងភេសជ្ជៈ",
"衛生管理": "ការគ្រប់គ្រងអនាម័យ",
"日本語版": "កំណែភាសាជប៉ុន",
"英語版": "ការបោះពុម្ពភាសាអង់គ្លេស",
"クメール語版": "ភាសាខ្មែរ",
"インドネシア語版": "កំណែឥណ្ឌូនេស៊ី",
"インドネシア語・正誤表": "កំហុសឥណ្ឌូនេស៊ី",
"ネパール語版": "កំណែភាសានេប៉ាល់",
"モンゴル語版": "កំណែម៉ុងហ្គោលី",
"ビルマ語版": "កំណែភូមា",
"ベトナム語版": "កំណែវៀតណាម",
"タイ語版": "កំណែភាសាថៃ",
"テキスト１": "អត្ថបទ ១",
"テキスト２": "អត្ថបទ ២",
"テキスト３": "អត្ថបទ ៣",
"テキスト４": "អត្ថបទ ៤",
"テキスト５": "អត្ថបទ ៥",
"ミャンマー(ビルマ)語版": "កំណែ​ភាសា​ភូមា (ភូមា)",
"カンボジア(クメール)語版": "ភាសាខ្មែរ (ខ្មែរ)",
"ミャンマー語版": "កំណែភូមា",
"中国語版": "កំណែភាសាចិន",
"付属資料": "ឯកសារ​ភ្ជាប់",
"用語集": "សទ្ទានុក្រម",

invitation_code: "លេខ​កូដ​ការ​អញ្ជើញ",
exam_calender: "កាលវិភាគប្រឡង",
move_exam_detail: "តើ​អ្នក​ចង់​ចូល​ទៅ​ទំព័រ​លម្អិត​តារាង​ពេល​ប្រឡង​ដែរ​ឬ​ទេ?",
move: "ផ្លាស់ទី",
plece_select_language: "សូមជ្រើសរើសភាសា",
select: "ជ្រើសរើស",
midle_category: "មុខរបរ",
select_industry_description: "នៅពេលចាប់ផ្តើម AELU អាចជ្រើសរើសបានត្រឹមតែ 3 ឧស្សាហកម្មប៉ុណ្ណោះ ដូច្នេះសូមជ្រើសរើសតែឧស្សាហកម្មដែលអ្នកចង់ធ្វើការ។ ប្រសិនបើអ្នកពេញចិត្តនឹងវា សូមចុច Next",
done_member_regist_description_2: "ចាប់ពីពេលនេះតទៅ យើងនឹងគាំទ្រ AELU ដើម្បីទទួលបានទិដ្ឋាការជំនាញជាក់លាក់មួយ ដោយរៀបចំការប្រឡងវិញ្ញាបនប័ត្រជាច្រើន។",
done_member_regist_2: "ការចុះឈ្មោះសមាជិកបានបញ្ចប់។",
is_exist_user: "អ្នកប្រើប្រាស់ដែលមានអាសយដ្ឋានអ៊ីមែលដូចគ្នាមានរួចហើយ។",
invitation_code_description: "(សូមបញ្ចូលលេខកូដអញ្ជើញពីស្ថាប័នបញ្ជូន ឬសាលាភាសាជប៉ុន បើមិនដូច្នេះទេ អេក្រង់ទូទាត់ចំណាយនឹងបង្ហាញឡើង ដូច្នេះកុំភ្លេចបញ្ចូលវា។)",
pleace_select_region: "សូមជ្រើសរើសខេត្តម្ចាស់ផ្ទះ",
pleace_add_messenger: "ទំនាក់ទំនងទាំងអស់នឹងត្រូវបានផ្ញើតាមរយៈសារ Facebook ដូច្នេះត្រូវប្រាកដថាបន្ថែមពួកគេ។",
add_messenger_bot: "ទទួលការជូនដំណឹង",
visa_application_description: "ទីតាំងផ្ទុកឯកសារដែលត្រូវការនៅពេលដាក់ពាក្យសុំទិដ្ឋាការជំនាញជាក់លាក់",
check_agree: "សូមយល់ព្រម",
sample_title: "នេះជាចំណងជើងអត់ចេះសោះ។ សូមកំណត់",
sample_description: "នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។ នេះ​គឺ​ជា​ការ​ពិពណ៌នា​អត់​ចេះ​សោះ។ សូមកំណត់។",
create_profile_error: "មានកំហុសក្នុងការបញ្ចូល។ សូមពិនិត្យមើលធាតុ",
setting_confirm: "សូមបញ្ជាក់ខ្លឹមសារបញ្ចូល ហើយចុះឈ្មោះ",
exam_learning: "ការរៀនប្រឡង",
recommend_problem_solve: "ដោះស្រាយសំណួរប្រឡងស្រដៀងគ្នា",
of: "នៃ",
see_solved_problem: "ដោះស្រាយបញ្ហាដែលអ្នកបានដោះស្រាយនាពេលកន្លងមក\n",
past_exam_collection: "\n សំណួរប្រឡងដែលបានលេចឡើងនាពេលកន្លងមក",
any_application_registration: "ការចុះឈ្មោះកម្មវិធីផ្សេងៗ",
mypage_visa_application: "ទិដ្ឋាការជំនាញជាក់លាក់\nកម្មវិធី",
applyt_exam_and_agent: "កម្មវិធីប្រឡង\nកម្មវិធីសេវាប្រូកស៊ី",
myapge_regist_accept_certificate: "តេស្តជំនាញ\nចុះឈ្មោះប្រឡង",
mypage_consultaion_service: "ការ​ប្រឹក្សា​ការ​សិក្សា\nសេវា",
consult: "ពិគ្រោះ",
of_exam_day: "កាលបរិច្ឆេទសាកល្បង",
your_ave_score: "ពិន្ទុមធ្យមសម្រាប់ការធ្វើតេស្ត \n របស់អ្នក។",
your_estimated_pass_rate: "\n អត្រាឆ្លងតាមការប៉ាន់ស្មានរបស់អ្នក។",
your_ave_score_fotter: "ពិន្ទុមធ្យមសម្រាប់ការធ្វើតេស្តរបស់អ្នក។",
your_estimated_pass_rate_fotter: "អត្រាឆ្លងកាត់ប៉ាន់ស្មាន",
mypage_study_text: "ទាញយកសៀវភៅសិក្សា\n",
exam_schedule: "កាលវិភាគប្រឡង",
resident_caption_title: "● អំពីការបង្ហោះប័ណ្ណស្នាក់នៅ ឬអត្តសញ្ញាណប័ណ្ណ",
resident_caption: "សូមបង្ហោះប័ណ្ណស្នាក់នៅ ឬអត្តសញ្ញាណប័ណ្ណដែលអាចបញ្ជាក់ព័ត៌មានក្នុងស៊ុមក្រហម។ \nសូមបង្ហោះប័ណ្ណស្នាក់នៅដែលមានសុពលភាព ឬអត្តសញ្ញាណប័ណ្ណដែលមិនទាន់ផុតកំណត់។ \nបង្ហោះរូបភាពពណ៌ជាទម្រង់ PDF ឬ JPG ។",
password_caption_title: "● អំពីការបង្ហោះពាក្យសម្ងាត់",
password_caption: "សូមបង្ហោះរូបភាពលិខិតឆ្លងដែនដែលបញ្ជាក់ឈ្មោះ/រូបថត/លេខពិសេស/ថ្ងៃខែឆ្នាំកំណើត/សញ្ជាតិ/ថ្ងៃផុតកំណត់ដូចបង្ហាញក្នុងស៊ុមក្រហម។ \nសូមបង្ហោះលិខិតឆ្លងដែនដែលមានសុពលភាពដែលមិនទាន់ផុតកំណត់។ \nបង្ហោះរូបភាពពណ៌ជាទម្រង់ PDF ឬ JPG ។",
title_help: "ជួយ",
step3_title_help: "សូមបញ្ចូលព័ត៌មានរបស់អ្នកឱ្យបានត្រឹមត្រូវ។",
lineid_input_help: "បើក LINE → Home → Settings → Profile → Scroll ដើម្បីមើល ID។ សូមបញ្ចូលលេខសម្គាល់នោះ។ ប្រសិនបើអ្នកមិនទាន់បានបង្កើតវាទេ សូមបង្កើតវា ហើយបញ្ចូលវា។",
country_input_help: "សូមជ្រើសរើសប្រទេសដែលមានសញ្ជាតិរបស់អ្នក។",
area_input_help: "ជ្រើសរើសប្រទេសនៃតំបន់របស់អ្នកដែលអ្នករស់នៅបច្ចុប្បន្ន។",
phone_input_help: "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក។",
issuing_input_help: "សូមជ្រើសរើសតំបន់ដែលអត្តសញ្ញាណប័ណ្ណរបស់អ្នកត្រូវបានចេញ។",
idtype_input_help: "សូមជ្រើសរើសប្រភេទលេខសម្គាល់។ សូមថតរូបដ៏ស្រស់ស្អាតរបស់អ្នកដែលបានជ្រើសរើស ហើយបង្ហោះវា។ សូម​បាញ់​ត្រង់​ដើម្បី​កុំ​ឲ្យ​មាន​ចំណុច​អង្កត់ទ្រូង ឬ​កាត់។",
invitation_input_help: "ប្រសិនបើអ្នកមានលេខកូដអញ្ជើញ សូមបញ្ចូលវា។",
exam_menu_help: "វានឹងមានសំណួរដែលស្រដៀងនឹងសំណួរដែលត្រូវបានសួរកាលពីអតីតកាល។ ដោះស្រាយសំណួរដដែលៗ ដើម្បីត្រៀមប្រឡង។",
past_menu_help: "អ្នកនឹងមានបញ្ហាដែលអ្នកបានដោះស្រាយនាពេលកន្លងមក។ ចូរយើងពិនិត្យមើលកំហុស។",
pastexam_menu_help: "នេះ​ជា​អត្ថបទ​សំណួរ​ប្រឡង​ដែល​ពិត​ជា​មាន​ក្នុង​អតីតកាល។",
text_menu_help: "អ្នក​អាច​មើល​សៀវភៅ​សិក្សា​ដើម្បី​សិក្សា​ចំណុច​សំខាន់ៗ​និង​រក​ឃើញ​នូវ​អ្វី​ដែល​អ្នក​មិន​យល់។",
visa_menu_help: "យើងនឹងជួយអ្នកឱ្យទទួលបានទិដ្ឋាការជំនាញជាក់លាក់មួយ។ ប្រសិនបើអ្នកចង់ទទួលបានទិដ្ឋាការសម្រាប់ជំនាញជាក់លាក់មួយ សូមដាក់ពាក្យនៅទីនេះ។",
agency_menu_help: "យើង​នឹង​ដាក់​ពាក្យ​សម្រាប់​ការ​ធ្វើ​តេស្ត​សមត្ថភាព​ជាក់លាក់​ក្នុង​នាម​អ្នក​។ ប្រសិនបើអ្នកចង់ធ្វើតេស្តជំនាញជាក់លាក់ សូមដាក់ពាក្យនៅទីនេះ។",
cer_menu_help: "ប្រសិនបើអ្នកបានធ្វើតេស្តសមត្ថភាពជាក់លាក់ និងមានវិញ្ញាបនបត្រឆ្លងកាត់ សូមចុះឈ្មោះនៅទីនេះ។",
service_menu_help: "ប្រសិនបើអ្នកមានចម្ងល់ ឬកង្វល់ សូមទាក់ទងមកយើងខ្ញុំតាមរយៈការជជែកនៅទីនេះ។",
occu_title_help: "សូមជ្រើសរើសមុខរបរដែលចង់បានរហូតដល់ 3។",
back: "ត្រឡប់មកវិញ",
before: "ទៅនឹងបញ្ហាមុន។",
srilank: "ស្រី​លង្កា",
reselect: "ប្រសិនបើអ្នកចង់ផ្លាស់ប្តូរឯកសារ សូមចុច &quot;ផ្ទុកលិខិតឆ្លងដែនរបស់អ្នក&quot; ម្តងទៀត ហើយជ្រើសរើសម្តងទៀត",
iphone_file: "សម្រាប់ iPhone សូមប្រើបន្ទាប់ពីបំប្លែងពីឯកសារ HEIC ទៅជាឯកសារ JPG ។",
file_transmit: "បម្លែងឯកសារ",
combodia: 'combodia',
}
